// import React, { useState } from "react";
// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";

// const SpeechToText = () => {
//   const { transcript, resetTranscript } = useSpeechRecognition();
//   const [isListening, setIsListening] = useState(false);

//   if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
//     return <div>Your browser does not support speech recognition.</div>;
//   }

//   const handleButtonClick = () => {
//     if (isListening) {
//       SpeechRecognition.stopListening();
//     } else {
//       SpeechRecognition.startListening({ continuous: true });
//     }
//     setIsListening(!isListening);
//   };

//   return (
//     <div>
//       <button onClick={handleButtonClick}>
//         {isListening ? "Stop Listening" : "Start Listening"}
//       </button>
//       <button onClick={resetTranscript}>Reset</button>
//       <p>{transcript}</p>
//     </div>
//   );
// };

// export default SpeechToText;
// import React, { useState } from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// // Custom Toolbar component
// const CustomToolbar = () => (
//   <div id="toolbar">
//     <select className="ql-header" defaultValue="" onChange={(e) => e.persist()}>
//       <option value="1"></option>
//       <option value="2"></option>
//       <option value=""></option>
//     </select>
//     <button className="ql-bold"></button>
//     <button className="ql-italic"></button>
//     <button className="ql-underline"></button>
//     <button className="ql-strike"></button>
//     <button className="ql-list" value="ordered"></button>
//     <button className="ql-list" value="bullet"></button>
//   </div>
// );

// const TextEditor = () => {
//   const [value, setValue] = useState("");

//   const handleChange = (content) => {
//     setValue(content);
//   };

//   const RenderHTML = ({ htmlString }) => {
//     return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
//   };

//   const htmlString = `<ol><li>ssdsdadsadsd</li><li>asdsadsad</li><li>asdsadsadsad</li><li>asdsadsadsa</li><li>asdsadsadsd</li></ol>`;

//   const handleSubmit = async () => {
//     const response = await fetch(
//       "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/parse-ques-set/?parse_ques_set_name=pop-test&user_name=viraj&client_id=1&client_branch_id=1",
//       {
//         method: "POST",
//         headers: {
//           accept: "application/json",
//           Authorization:
//             "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzaWRkaGFydGgiLCJleHAiOjE3MzE1ODc5OTF9.xGtbrAFZ8HNXDLgRBxMtsTvQpxJfaBsAvgeXRXqN26k",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           parse_ques_set_questions_list: [
//             {
//               parse_ques_set_question_id: null,
//               parse_ques_set_id: null,
//               parse_ques_set_ques_no: 1,
//               parse_ques_set_ques_type: 1,
//               question_text: value,
//               status: 0,
//               initial_reviewed_by: "me",
//               initial_reviewed_on: new Date().toISOString(),
//             },
//           ],
//           parse_ques_set_options_list: [
//             {
//               parse_ques_set_option_id: null,
//               parse_ques_set_id: null,
//               parse_ques_set_question_id: null,
//               parse_ques_option_no: 1,
//               parse_ques_option_bool_type: 1,
//               parse_ques_option_text: "string",
//               parse_ques_option_correct_flag: 1,
//               parse_ques_option_weightage: 1,
//             },
//           ],
//           parse_ques_tagging_list: [
//             {
//               parse_ques_set_id: null,
//               parse_ques_set_question_id: null,
//               parse_ques_tag_id: 1,
//               parse_ques_tag_value: 1,
//             },
//           ],
//         }),
//       }
//     );

//     if (response.ok) {
//       console.log("Data submitted successfully");
//     } else {
//       console.error("Error submitting data");
//     }
//   };

//   return (
//     <>
//       <div>
//         <CustomToolbar />
//       </div>
//       <div style={{ padding: "50px" }}>
//         <button>Button 1</button>
//         <button>Button 2</button>
//         <button>Button 3</button>
//         <button>Button 4</button>
//       </div>
//       <div>
//         <ReactQuill
//           value={value}
//           onChange={handleChange}
//           modules={{ toolbar: "#toolbar" }}
//         />
//       </div>
//       <button onClick={handleSubmit}>Submit</button>
//       <div style={{ padding: "30px" }}>
//         <h1>Render HTML Example</h1>
//         <RenderHTML htmlString={htmlString} />
//         <style jsx>{`
//           ol,
//           ul {
//             padding-left: 20px;
//             list-style-type: disc;
//           }
//           li {
//             margin-bottom: 10px;
//           }
//         `}</style>
//       </div>
//     </>
//   );
// };

// export default TextEditor;

// import React from "react";

// const RenderHTML = ({ htmlString }) => {
//   return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
// };

// const POP3 = () => {
//   const htmlString = `<ol><li><strong>bold letters<em> with italic now <u>and now underscore </u></em></strong></li><li>just the same but now normal</li><li>3rd line just for fun and seeing li ul tags</li></ol>`;

//   return (
//     <div style={{ padding: "30px" }}>
//       <h1>Render HTML Example</h1>
//       <RenderHTML htmlString={htmlString} />
//       <style jsx>{`
//         ol, ul {
//           padding-left: 20px;
//           list-style-type: disc;
//         }
//         li {
//           margin-bottom: 10px;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default POP3;

// import React from "react";
// import FormulaQuill from "./FileComp6";
// const RenderHTML = ({ htmlString }) => {
//   return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
// };
// const POP3 = () => {
//   // const htmlString = `<p><strong><em><u>x</u></em></strong><sub><strong><em><u>2 </u></em></strong></sub><strong><em><u> </u></em></strong> <span class=\"ql-formula\" data-value=\" x^n + y^n = z^n \">﻿<span contenteditable=\"false\"><span class=\"katex\"><span class=\"katex-mathml\"><math xmlns=\"http://www.w3.org/1998/Math/MathML\"><semantics><mrow><msup><mi>x</mi><mi>n</mi></msup><mo>+</mo><msup><mi>y</mi><mi>n</mi></msup><mo>=</mo><msup><mi>z</mi><mi>n</mi></msup></mrow><annotation encoding=\"application/x-tex\"> x^n + y^n = z^n </annotation></semantics></math></span><span class=\"katex-html\" aria-hidden=\"true\"><span class=\"base\"><span class=\"strut\" style=\"height: 0.7477em; vertical-align: -0.0833em;\"></span><span class=\"mord\"><span class=\"mord mathnormal\">x</span><span class=\"msupsub\"><span class=\"vlist-t\"><span class=\"vlist-r\"><span class=\"vlist\" style=\"height: 0.6644em;\"><span class=\"\" style=\"top: -3.063em; margin-right: 0.05em;\"><span class=\"pstrut\" style=\"height: 2.7em;\"></span><span class=\"sizing reset-size6 size3 mtight\"><span class=\"mord mathnormal mtight\">n</span></span></span></span></span></span></span></span><span class=\"mspace\" style=\"margin-right: 0.2222em;\"></span><span class=\"mbin\">+</span><span class=\"mspace\" style=\"margin-right: 0.2222em;\"></span></span><span class=\"base\"><span class=\"strut\" style=\"height: 0.8588em; vertical-align: -0.1944em;\"></span><span class=\"mord\"><span class=\"mord mathnormal\" style=\"margin-right: 0.0359em;\">y</span><span class=\"msupsub\"><span class=\"vlist-t\"><span class=\"vlist-r\"><span class=\"vlist\" style=\"height: 0.6644em;\"><span class=\"\" style=\"top: -3.063em; margin-right: 0.05em;\"><span class=\"pstrut\" style=\"height: 2.7em;\"></span><span class=\"sizing reset-size6 size3 mtight\"><span class=\"mord mathnormal mtight\">n</span></span></span></span></span></span></span></span><span class=\"mspace\" style=\"margin-right: 0.2778em;\"></span><span class=\"mrel\">=</span><span class=\"mspace\" style=\"margin-right: 0.2778em;\"></span></span><span class=\"base\"><span class=\"strut\" style=\"height: 0.6644em;\"></span><span class=\"mord\"><span class=\"mord mathnormal\" style=\"margin-right: 0.044em;\">z</span><span class=\"msupsub\"><span class=\"vlist-t\"><span class=\"vlist-r\"><span class=\"vlist\" style=\"height: 0.6644em;\"><span class=\"\" style=\"top: -3.063em; margin-right: 0.05em;\"><span class=\"pstrut\" style=\"height: 2.7em;\"></span><span class=\"sizing reset-size6 size3 mtight\"><span class=\"mord mathnormal mtight\">n</span></span></span></span></span></span></span></span></span></span></span></span>﻿</span></p>`;
//   const htmlString = `<p>E=mc<sup>2 </sup>x<sup>2</sup>/a<sup>2</sup> - y<sup>2</sup>/b<sup>2</sup> = 1 </p>`;

//   return (
//     <>
//       {" "}
//       <div>POP3</div>
//       <FormulaQuill />
//       <RenderHTML htmlString={htmlString} />
//     </>
//   );
// };

// export default POP3;

// import React from "react";
// import ReactQuill, { Quill } from "react-quill";
// import katex from "katex";
// import "react-quill/dist/quill.snow.css";
// import "katex/dist/katex.min.css";

// window.katex = katex; // Make sure KaTeX is available globally

// class Editor extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       editorHtml: "",
//       theme: "snow",
//       placeholder: "Write something...",
//       isCharacterPickerOpen: false,
//     };
//     this.handleChange = this.handleChange.bind(this);
//     this.handleSubmit = this.handleSubmit.bind(this);
//     this.insertSymbol = this.insertSymbol.bind(this);
//   }

//   handleChange(html) {
//     const cleanedHtml = html
//       .replace(/\\\((.*?)\\\)/g, "$1")
//       .replace(/\\\[(.*?)\\\]/g, "$1");

//     this.setState({ editorHtml: cleanedHtml });
//   }

//   // Function to handle form submission
//   async handleSubmit() {
//     const { editorHtml } = this.state;

//     try {
//       const response = await fetch(
//         "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/parse-ques-set/?parse_ques_set_name=pop-test&user_name=viraj&client_id=1&client_branch_id=1",
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             Authorization:
//               "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzaWRkaGFydGgiLCJleHAiOjE3MzE1ODc5OTF9.xGtbrAFZ8HNXDLgRBxMtsTvQpxJfaBsAvgeXRXqN26k",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             parse_ques_set_questions_list: [
//               {
//                 parse_ques_set_question_id: null,
//                 parse_ques_set_id: null,
//                 parse_ques_set_ques_no: 1,
//                 parse_ques_set_ques_type: 1,
//                 question_text: editorHtml,
//                 status: 0,
//                 initial_reviewed_by: "me",
//                 initial_reviewed_on: new Date().toISOString(),
//               },
//             ],
//             parse_ques_set_options_list: [
//               {
//                 parse_ques_set_option_id: null,
//                 parse_ques_set_id: null,
//                 parse_ques_set_question_id: null,
//                 parse_ques_option_no: 1,
//                 parse_ques_option_bool_type: 1,
//                 parse_ques_option_text: "string",
//                 parse_ques_option_correct_flag: 1,
//                 parse_ques_option_weightage: 1,
//               },
//             ],
//             parse_ques_tagging_list: [
//               {
//                 parse_ques_set_id: null,
//                 parse_ques_set_question_id: null,
//                 parse_ques_tag_id: 1,
//                 parse_ques_tag_value: 1,
//               },
//             ],
//           }),
//         }
//       );

//       if (response.ok) {
//         console.log("Data submitted successfully");
//       } else {
//         console.error("Error submitting data");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   }

//   insertSymbol(symbol) {
//     const quill = this.reactQuillRef.getEditor();
//     const cursorPosition = quill.getSelection().index;
//     quill.insertText(cursorPosition, symbol);
//     quill.setSelection(cursorPosition + symbol.length);
//   }

//   render() {
//     // List of special mathematical symbols
//     const characters = [
//       "α",
//       "β",
//       "γ",
//       "δ",
//       "ε",
//       "ζ",
//       "η",
//       "θ",
//       "ι",
//       "κ",
//       "λ",
//       "μ",
//       "ν",
//       "ξ",
//       "ο",
//       "π",
//       "ρ",
//       "σ",
//       "τ",
//       "υ",
//       "φ",
//       "χ",
//       "ψ",
//       "ω",
//       "Γ",
//       "Δ",
//       "Θ",
//       "Λ",
//       "Ξ",
//       "Π",
//       "Σ",
//       "Υ",
//       "Φ",
//       "Ψ",
//       "Ω",
//       "+",
//       "-",
//       "×",
//       "÷",
//       "=",
//       "≠",
//       "<",
//       ">",
//       "≤",
//       "≥",
//       "±",
//       "≈",
//       "∑",
//       "∏",
//       "√",
//       "∛",
//       "∜",
//       "∂",
//       "∫",
//       "∬",
//       "∭",
//       "∇",
//       "∅",
//       "∈",
//       "∉",
//       "∋",
//       "⊂",
//       "⊃",
//       "⊆",
//       "⊇",
//       "∪",
//       "∩",
//       "∠",
//       "∧",
//       "∨",
//       "¬",
//       "⇒",
//       "⇔",
//       "∀",
//       "∃",
//       "⊗",
//       "⊕",
//       "⊙",
//       "⊢",
//       "⊨",
//       "∠",
//       "⊥",
//       "∥",
//       "≅",
//       "∼",
//       "≈",
//       "⊿",
//       "½",
//       "¼",
//       "¾",
//       "‰",
//       "←",
//       "→",
//       "↑",
//       "↓",
//       "↔",
//       "↕",
//       "⇐",
//       "⇒",
//       "⇑",
//       "⇓",
//       "⇔",
//       "⊗",
//       "⊕",
//       "⊖",
//       "⊙",
//       "∝",
//       "⊂",
//       "⊃",
//       "⊄",
//       "⊆",
//       "⊇",
//       "⊏",
//       "⊐",
//       "⊑",
//       "⊒",
//     ];

//     return (
//       <div>
//         <div id="toolbar">
//           <select
//             className="ql-symbols"
//             onChange={(e) => this.insertSymbol(e.target.value)}
//           >
//             <option value="" selected disabled hidden>
//               Select Symbol
//             </option>
//             {characters.map((char, index) => (
//               <option key={index} value={char}>
//                 {char}
//               </option>
//             ))}
//           </select>
//         </div>
//         <ReactQuill
//           ref={(el) => {
//             this.reactQuillRef = el;
//           }}
//           theme={this.state.theme}
//           onChange={this.handleChange}
//           value={this.state.editorHtml}
//           modules={Editor.modules}
//           formats={Editor.formats}
//           bounds={".app"}
//           placeholder={this.state.placeholder}
//         />
//         <button onClick={this.handleSubmit} style={{ marginTop: "20px" }}>
//           Submit
//         </button>
//       </div>
//     );
//   }
// }

// // Quill modules with the custom toolbar
// Editor.modules = {
//   toolbar: {
//     container: [
//       ["bold", "italic", "underline", "strike"],
//       // ["blockquote", "code-block"],
//       [{ list: "ordered" }, { list: "bullet" }],
//       [{ script: "sub" }, { script: "super" }],
//       [{ header: [1, 2, 3, false] }],
//       [{ font: [] }],
//       // [{ size: ["small", "normal", "large", "huge"] }],
//       ["link", "image", "formula"],
//       [{ color: [] }, { background: [] }],
//       [{ align: [] }],
//       ["clean"],
//       ["symbols"], // Custom symbol dropdown
//     ],
//     handlers: {
//       // Custom handler for symbols
//       symbols: function (value) {
//         if (value) {
//           this.quill.insertText(this.quill.getSelection().index, value);
//         }
//       },
//     },
//   },
// };

// Editor.formats = [
//   "header",
//   "bold",
//   "italic",
//   "underline",
//   // "strike",
//   // "blockquote",
//   "list",
//   "bullet",
//   "script",
//   "link",
//   "image",
//   "formula",
//   "color",
//   "background",
//   "align",
//   "font",
//   // "size",
// ];

// export default Editor;

// import React from "react";
// import RAC from "./FileComp6";
// const pop3 = () => {
//   return <RAC />;
// };

// export default pop3;

// import React from "react";
// import ReactQuill, { Quill } from "react-quill";
// import katex from "katex";
// import "react-quill/dist/quill.snow.css";
// import "katex/dist/katex.min.css";

// window.katex = katex; // Make sure KaTeX is available globally

// class Editor extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       editorHtml: "",
//       theme: "snow",
//       placeholder: "Write something...",
//     };
//     this.handleChange = this.handleChange.bind(this);
//   }

//   handleChange(html) {
//     const cleanedHtml = html
//       .replace(/\\\((.*?)\\\)/g, "$1")
//       .replace(/\\\[(.*?)\\\]/g, "$1");

//     this.setState({ editorHtml: cleanedHtml });
//   }

//   insertSymbol(symbol) {
//     const quill = this.reactQuillRef.getEditor();
//     const cursorPosition = quill.getSelection().index;
//     quill.insertText(cursorPosition, symbol);
//     quill.setSelection(cursorPosition + symbol.length);
//   }

//   render() {
//     return (
//       <div>
//         <div id="toolbar">
//           <select
//             className="ql-symbols"
//             onChange={(e) => this.insertSymbol(e.target.value)}
//           >
//             <option value="" selected disabled hidden>
//               Symbols
//             </option>
//             <option value="θ">Theta (θ)</option>
//             <option value="γ">Gamma (γ)</option>
//             <option value="π">Pi (π)</option>
//             <option value="α">Alpha (α)</option>
//             <option value="β">Beta (β)</option>
//             <option value="Σ">Sigma (Σ)</option>
//             <option value="Ω">Omega (Ω)</option>
//           </select>
//         </div>
//         <ReactQuill
//           ref={(el) => {
//             this.reactQuillRef = el;
//           }}
//           theme={this.state.theme}
//           onChange={this.handleChange}
//           value={this.state.editorHtml}
//           modules={Editor.modules}
//           formats={Editor.formats}
//           bounds={".app"}
//           placeholder={this.state.placeholder}
//         />
//       </div>
//     );
//   }
// }

// // Quill modules with the custom toolbar
// Editor.modules = {
//   toolbar: {
//     container: [
//       ["bold", "italic", "underline", "strike"],
//       ["blockquote", "code-block"],
//       [{ list: "ordered" }, { list: "bullet" }],
//       [{ script: "sub" }, { script: "super" }],
//       [{ header: [1, 2, 3, false] }],
//       [{ font: [] }],
//       [{ size: ["small", "normal", "large", "huge"] }],
//       ["link", "image", "formula"],
//       [{ color: [] }, { background: [] }],
//       [{ align: [] }],
//       ["clean"],
//       ["symbols"], // Custom symbol dropdown
//     ],
//     handlers: {
//       // Custom handler for symbols
//       symbols: function (value) {
//         if (value) {
//           this.quill.insertText(this.quill.getSelection().index, value);
//         }
//       },
//     },
//   },
// };

// Editor.formats = [
//   "header",
//   "bold",
//   "italic",
//   "underline",
//   "strike",
//   "blockquote",
//   "list",
//   "bullet",
//   "script",
//   "link",
//   "image",
//   "formula",
//   "color",
//   "background",
//   "align",
//   "font",
//   "size",
// ];

// export default Editor;

// import React, { useState } from "react";

// function SvgDiagramRenderer() {
//   const [svgInput, setSvgInput] = useState(""); // State to store the SVG input
//   const [renderedContent, setRenderedContent] = useState(""); // State to store the rendered content

//   // Function to handle the SVG input change
//   const handleInputChange = (event) => {
//     setSvgInput(event.target.value);
//   };

//   // Function to render the SVG content
//   const handleRenderContent = () => {
//     let content = svgInput.trim();

//     // Wrap the content with <svg> tags if they are not already present
//     if (!content.startsWith("<svg") || !content.endsWith("</svg>")) {
//       content = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="100">${content}</svg>`;
//     }

//     setRenderedContent(content); // Set the SVG content to render
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>SVG Diagram Renderer</h2>
//       <textarea
//         value={svgInput}
//         onChange={handleInputChange}
//         placeholder="Paste your SVG content here..."
//         style={{ width: "100%", height: "100px", marginBottom: "20px" }}
//       ></textarea>
//       <br />
//       <button onClick={handleRenderContent} style={{ marginBottom: "20px" }}>
//         Render Diagram
//       </button>
//       <div>
//         <h3>Rendered Diagram:</h3>
//         {/* Render the SVG content using dangerouslySetInnerHTML */}
//         <div
//           dangerouslySetInnerHTML={{ __html: renderedContent }}
//           style={{ border: "1px solid #ccc", padding: "10px" }}
//         ></div>
//       </div>
//     </div>
//   );
// }

// export default SvgDiagramRenderer;

// import React, { useState } from "react";
// import MathJax from "react-mathjax2"; // Import the MathJax library

// const MathInputConverter = () => {
//   const [inputText, setInputText] = useState("");

//   const handleChange = (event) => {
//     setInputText(event.target.value);
//   };

//   return (
//     <div>
//       <h2>Math Input Converter</h2>
//       <textarea
//         rows="4"
//         cols="80"
//         value={inputText}
//         onChange={handleChange}
//         style={{ marginBottom: "20px", padding: "10px" }}
//       />
//       <div>
//         <MathJax.Context input="tex">
//           <MathJax.Text text={inputText} />
//         </MathJax.Context>
//       </div>
//     </div>
//   );
// };

// export default MathInputConverter;

// import React, { useState } from "react";

// const HtmlRenderer = () => {
//   const [inputHtml, setInputHtml] = useState("");

//   return (
//     <div>
//       <h2>HTML Input and Renderer</h2>
//       <textarea
//         rows="6"
//         cols="80"
//         value={inputHtml}
//         onChange={(e) => setInputHtml(e.target.value)}
//         style={{ marginBottom: "20px", padding: "10px" }}
//       />
//       <h3>Rendered HTML:</h3>
//       <div
//         style={{ border: "1px solid #ccc", padding: "10px" }}
//         dangerouslySetInnerHTML={{ __html: inputHtml }}
//       />
//     </div>
//   );
// };

// export default HtmlRenderer;

// import React, { useState } from "react";
// import { Cropper } from "react-cropper";
// import "cropperjs/dist/cropper.css";

// const CustomTextEditorWithCropper = () => {
//   const [content, setContent] = useState([]); // Holds text and images as a structured JSON
//   const [currentText, setCurrentText] = useState(""); // Temporary text input
//   const [image, setImage] = useState(null); // Image for cropping
//   const cropperRef = React.useRef(null); // Reference to the cropper

//   // Handle adding text to the content
//   const handleAddText = () => {
//     if (currentText.trim()) {
//       setContent((prev) => [...prev, { type: "text", value: currentText }]);
//       setCurrentText("");
//     }
//   };

//   // Handle image file selection
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = () => {
//         setImage(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Crop the image and add it to the content
//   const handleCrop = () => {
//     const cropper = cropperRef.current?.cropper;
//     if (cropper) {
//       const croppedDataUrl = cropper.getCroppedCanvas().toDataURL();
//       setContent((prev) => [...prev, { type: "image", value: croppedDataUrl }]);
//       setImage(null); // Clear cropper
//     }
//   };

//   // Send the structured content
//   const handleSend = () => {
//     console.log("Sending content:", JSON.stringify(content));
//     alert("Content sent successfully!");
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Custom Text Editor with Image Cropping</h2>

//       {/* Text Area for entering text */}
//       <textarea
//         value={currentText}
//         onChange={(e) => setCurrentText(e.target.value)}
//         placeholder="Type your text here..."
//         style={{ width: "100%", height: "100px", marginBottom: "10px" }}
//       />
//       <button onClick={handleAddText} style={{ marginBottom: "20px" }}>
//         Add Text
//       </button>

//       {/* Hidden file input for image upload */}
//       <input
//         type="file"
//         accept="image/*"
//         id="fileInput"
//         style={{ display: "none" }}
//         onChange={handleFileChange}
//       />
//       <button
//         onClick={() => document.getElementById("fileInput").click()}
//         style={{ marginBottom: "20px" }}
//       >
//         Upload Image
//       </button>

//       {/* Image cropper */}
//       {image && (
//         <div style={{ marginBottom: "20px" }}>
//           <Cropper
//             src={image}
//             style={{ height: 300, width: "100%" }}
//             aspectRatio={16 / 9}
//             viewMode={1}
//             guides={true}
//             ref={cropperRef}
//           />
//           <button onClick={handleCrop} style={{ marginTop: "10px" }}>
//             Crop and Add to Content
//           </button>
//         </div>
//       )}

//       {/* Display the content */}
//       <div style={{ marginTop: "20px", border: "1px solid #ddd", padding: "10px" }}>
//         <h3>Preview:</h3>
//         {content.map((item, index) => (
//           <div key={index} style={{ marginBottom: "10px" }}>
//             {item.type === "text" ? (
//               <p>{item.value}</p>
//             ) : (
//               <img src={item.value} alt={`Cropped ${index}`} style={{ maxWidth: "100%" }} />
//             )}
//           </div>
//         ))}
//       </div>

//       <button
//         onClick={handleSend}
//         style={{ padding: "10px 20px", fontSize: "16px", marginTop: "20px" }}
//       >
//         Send Content
//       </button>
//     </div>
//   );
// };

// export default CustomTextEditorWithCropper;

// import React, { useState } from "react";
// import katex from "katex";
// import "katex/dist/katex.min.css";

// const LatexToHTMLConverter = () => {
//   const [input, setInput] = useState("");
//   const [output, setOutput] = useState("");

//   const convertLatexToHTML = (text) => {
//     const regex = /\\\((.*?)\\\)/g; // Match LaTeX inline math: \( ... \)
//     return text.replace(regex, (_, latex) => {
//       try {
//         // Convert LaTeX to HTML
//         return katex.renderToString(latex, {
//           throwOnError: false,
//         });
//       } catch (error) {
//         console.error("Error converting LaTeX:", error);
//         return latex; // Return raw LaTeX on error
//       }
//     });
//   };

//   const handleConvert = () => {
//     const htmlOutput = convertLatexToHTML(input);
//     setOutput(htmlOutput);
//   };

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <h3>Latex to Normal HTML Converter</h3>
//       <textarea
//         value={input}
//         onChange={(e) => setInput(e.target.value)}
//         placeholder="Enter LaTeX with text here..."
//         rows="5"
//         style={{ width: "100%", marginBottom: "10px" }}
//       />
//       <button onClick={handleConvert} style={{ marginBottom: "10px" }}>
//         Convert to HTML
//       </button>
//       <div
//         style={{
//           border: "1px solid #ccc",
//           padding: "10px",
//           whiteSpace: "pre-wrap",
//         }}
//         dangerouslySetInnerHTML={{ __html: output }}
//       />
//     </div>
//   );
// };

// export default LatexToHTMLConverter;

// import React, { useState, useEffect } from "react";

// const RenderContent = () => {
//   const [content, setContent] = useState("");

//   // Fetch the content from the API
//   useEffect(() => {
//     const fetchContent = async () => {
//       try {
//         const response = await fetch("https://your-api.com/get-content", {
//           headers: {
//             Authorization: "Bearer your-token",
//           },
//         });
//         const data = await response.json();
//         setContent(data.htmlContent); // Assuming `data.htmlContent` contains the HTML
//       } catch (error) {
//         console.error("Error fetching content:", error);
//       }
//     };

//     fetchContent();
//   }, []);

//   return (
//     <div>
//       <h1>Rendered Content</h1>
//       {/* Render the content using dangerouslySetInnerHTML */}
//       <div dangerouslySetInnerHTML={{ __html: content }} />
//     </div>
//   );
// };

// export default RenderContent;

// import React, { useState, useRef } from 'react';
// import Cropper from 'react-easy-crop';
// import { getCroppedImg } from './cropImageHelper'; // Helper for cropping images

// const TextboxWithImage = () => {
//   const [content, setContent] = useState([]);
//   const [imageSrc, setImageSrc] = useState(null);
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
//   const [cropSize, setCropSize] = useState({ width: 300, height: 200 });
//   const [isCropping, setIsCropping] = useState(false);
//   const contentEditableRef = useRef(null);

//   const handleInput = () => {
//     const contentNodes = Array.from(contentEditableRef.current.childNodes);
//     const newContent = contentNodes.map((node) => {
//       if (node.nodeType === 3) {
//         return { type: 'text', value: node.textContent };
//       } else if (node.nodeName === 'IMG') {
//         return { type: 'image', value: node.src, name: node.alt || 'image' };
//       }
//       return null;
//     }).filter(Boolean);

//     setContent(newContent);
//   };

//   const handlePaste = (e) => {
//     e.preventDefault();
//     const items = e.clipboardData.items;
//     for (let item of items) {
//       if (item.type.startsWith('image/')) {
//         const blob = item.getAsFile();
//         const reader = new FileReader();
//         reader.onload = (event) => {
//           setImageSrc(event.target.result);
//           setIsCropping(true);
//         };
//         reader.readAsDataURL(blob);
//       }
//     }
//   };

//   const onCropComplete = (croppedArea, croppedAreaPixels) => {
//     setCroppedAreaPixels(croppedAreaPixels);
//   };

//   const addCroppedImage = async () => {
//     try {
//       const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
//       const img = document.createElement('img');
//       img.src = croppedImage;
//       img.alt = 'cropped-image';
//       img.style.maxWidth = '100%';
//       contentEditableRef.current.appendChild(img);
//       handleInput();
//       setIsCropping(false);
//       setImageSrc(null);
//     } catch (error) {
//       console.error('Error cropping image:', error);
//     }
//   };

//   const cancelCropping = () => {
//     setIsCropping(false);
//     setImageSrc(null);
//   };

//   const handleResizeWidth = (e) => {
//     setCropSize((prev) => ({
//       ...prev,
//       width: Math.max(50, Number(e.target.value)), // Minimum width is 50px
//     }));
//   };

//   const handleResizeHeight = (e) => {
//     setCropSize((prev) => ({
//       ...prev,
//       height: Math.max(50, Number(e.target.value)), // Minimum height is 50px
//     }));
//   };

//   return (
//     <div>
//       <div
//         contentEditable
//         ref={contentEditableRef}
//         onInput={handleInput}
//         onPaste={handlePaste}
//         style={{
//           border: '1px solid #ccc',
//           padding: '10px',
//           minHeight: '300px',
//           maxWidth: '1000px',
//           overflowY: 'auto',
//         }}
//       ></div>
//       <button
//         onClick={() => console.log(content)}
//         style={{ marginTop: '10px' }}
//       >
//         Log Content
//       </button>
//       <pre>
//         <strong>Content:</strong> {JSON.stringify(content, null, 2)}
//       </pre>

//       {/* Cropping Modal */}
//       {isCropping && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             backgroundColor: 'rgba(0, 0, 0, 0.8)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             flexDirection: 'column',
//           }}
//         >
//           <div
//             style={{
//               position: 'relative',
//               width: '80vw',
//               height: '80vh',
//               backgroundColor: '#fff',
//             }}
//           >
//             <Cropper
//               image={imageSrc}
//               crop={crop}
//               cropSize={cropSize}
//               onCropChange={setCrop}
//               onCropComplete={onCropComplete}
//               aspect={null} // No aspect ratio for free-form cropping
//             />
//           </div>
//           <div style={{ marginTop: '10px' }}>
//             <label>
//               Width:
//               <input
//                 type="number"
//                 value={cropSize.width}
//                 onChange={handleResizeWidth}
//                 style={{ marginLeft: '5px', width: '70px' }}
//               />
//             </label>
//             <label style={{ marginLeft: '15px' }}>
//               Height:
//               <input
//                 type="number"
//                 value={cropSize.height}
//                 onChange={handleResizeHeight}
//                 style={{ marginLeft: '5px', width: '70px' }}
//               />
//             </label>
//           </div>
//           <div style={{ marginTop: '10px' }}>
//             <button onClick={addCroppedImage}>Add Cropped Image</button>
//             <button onClick={cancelCropping} style={{ marginLeft: '10px' }}>
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TextboxWithImage;

// import React from "react";

// const postData = async () => {
//   const url = 'https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/post-parse-question-manual?parse_ques_set_id=1&parse_ques_set_ques_no=49&parse_ques_set_ques_type=1&question_text=Test%20single%20question';

//   const bodyData = {
//     parse_ques_set_options_list: [
//       {
//         parse_ques_set_option_id: null,
//         parse_ques_set_id: null,
//         parse_ques_set_question_id: null,
//         parse_ques_option_no: 1,
//         parse_ques_option_bool_type: 1,
//         parse_ques_option_text: "option 1",
//         parse_ques_option_correct_flag: 1,
//         parse_ques_option_weightage: 1,
//       },
//       {
//         parse_ques_set_option_id: null,
//         parse_ques_set_id: null,
//         parse_ques_set_question_id: null,
//         parse_ques_option_no: 2,
//         parse_ques_option_bool_type: 1,
//         parse_ques_option_text: "option 2",
//         parse_ques_option_correct_flag: 1,
//         parse_ques_option_weightage: 1,
//       },
//       {
//         parse_ques_set_option_id: null,
//         parse_ques_set_id: null,
//         parse_ques_set_question_id: null,
//         parse_ques_option_no: 3,
//         parse_ques_option_bool_type: 1,
//         parse_ques_option_text: "option 2",
//         parse_ques_option_correct_flag: 1,
//         parse_ques_option_weightage: 1,
//       },
//     ],
//     parse_ques_tagging_list: [
//       {
//         parse_ques_set_id: null,
//         parse_ques_set_question_id: null,
//         parse_ques_tag_id: 1,
//         parse_ques_tag_value_id: 1,
//       },
//     ],
//   };

//   try {
//     const response = await fetch(url, {
//       method: 'POST',
//       headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(bodyData),
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const result = await response.json();
//     console.log("Response Data:", result);
//   } catch (error) {
//     console.error("Error:", error);
//   }
// };

// const App = () => {
//   return (
//     <div>
//       <button onClick={postData}>Send POST Request</button>
//     </div>
//   );
// };

// export default App;

// import React, { useState, useEffect } from 'react';

// const MultipleImageStorage = () => {
//   const [imageURLs, setImageURLs] = useState([]);

//   useEffect(() => {
//     const storedImageURLs = JSON.parse(localStorage.getItem('imageURLs')) || [];
//     setImageURLs(storedImageURLs);
//   }, []);

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImageURLs = [];

//     files.forEach(file => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         newImageURLs.push(reader.result);
//         if (newImageURLs.length === files.length) {
//           const updatedImageURLs = [...imageURLs, ...newImageURLs];
//           localStorage.setItem('imageURLs', JSON.stringify(updatedImageURLs));
//           setImageURLs(updatedImageURLs);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   return (
//     <div>
//       <input type="file" multiple onChange={handleImageUpload} />
//       <div>
//         {imageURLs.map((url, index) => (
//           <img key={index} src={url} alt={`Stored ${index}`} style={{ width: '100px', margin: '10px' }} />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MultipleImageStorage;

// import React, { useState, useEffect } from "react";

// const MultipleImageStorage = () => {
//   const questionsData = [
//     [
//       {
//         question_id: 4567,
//         ques_no: 1,
//         ques_type: 1,
//         question_text:
//           "Which imgsrc=https://dseinfotech.s3.amazonaws.com/QID4567_IMG1_image1.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=b3ffa729e93912da598c611b485733d35feb660625ff69e42032e33bf793ae7f alcohol is most reactive imgsrc=https://dseinfotech.s3.amazonaws.com/QID4567_IMG2_image2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=5f83ab0a8a92feddfde559ddf15961357193b2c09d2008031696bcb3014673b6 in esterification reaction imgsrc=https://dseinfotech.s3.amazonaws.com/QID4567_IMG3_image3.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=b46d593d989ba95f72ae9925ae1179efa30a0eb25ee2057c498c5d922ddc959c ? ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:38",
//         options: [
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text:
//               "\\(\\begin{matrix} CH_{3\\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ } \\\\ |\\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\  \\\\ CH_{3} - CH - CH_{2} - OH \\end{matrix}\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "\\(CH_{3}CH_{2}OH\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "\\(CH_{3}OH\\ \\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "\\(\\left( CH_{3} \\right)_{3}C - OH\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4568,
//         ques_no: 2,
//         ques_type: 1,
//         question_text:
//           "\\(\\int_{}^{}\\frac{1}{(x + 4)^{8/7}(x - 3)^{6/7}}dx\\) is equal to",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:40",
//         options: [
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text:
//               "\\(\\frac{1}{7}\\left( \\frac{x - 3}{x + 4} \\right)^{\\frac{1}{7}} + C\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text:
//               "\\(\\left( \\frac{x - 3}{x + 4} \\right)^{\\frac{1}{7}} + C\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text:
//               "\\(\\left( \\frac{x + 4}{x - 3} \\right)^{\\frac{1}{7}} + C\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text:
//               "\\(\\frac{1}{7}\\left( \\frac{x + 4}{x - 3} \\right)^{\\frac{1}{7}} + C\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4569,
//         ques_no: 3,
//         ques_type: 1,
//         question_text:
//           "[Cu(NH3)4]SO4 is a blue soluble complex. The blue colour of this complex is due to the presence of ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:40",
//         options: [
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "[Cu(NH3)4]{2+}",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text: "\\(SO_{4}^{2 -}\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "Cu{2+}",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "[Cu(NH3)6]{2+}",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4570,
//         ques_no: 4,
//         ques_type: 1,
//         question_text:
//           "On adding inert gas at constant volume, which, of the following, equilibrium shifts in forward direction? ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:41",
//         options: [
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text:
//               "\\(PCl_{5}(g) \\rightleftharpoons PCl_{3}(g) + Cl_{2}(g)\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text:
//               "\\(N_{2}(g) + 3H_{2}(g) \\rightleftharpoons 2NH_{3}(g)\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "None of these",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text: "\\(H_{2}(g) + I_{2}(g) \\rightleftharpoons 2HI(g)\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4571,
//         ques_no: 5,
//         ques_type: 1,
//         question_text:
//           "The pKa is highest, for which of the following compounds? ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:41",
//         options: [
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "\\(HCOOH\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text: "\\(C_{6}H_{5}COOH\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "\\(\\left( CH_{3} \\right)_{2}CHCOOH\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "\\(CH_{3}COOH\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4572,
//         ques_no: 6,
//         ques_type: 1,
//         question_text:
//           "In which of the following cases, value of the Van’t Hoff factor (i) is the highest? ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:41",
//         options: [
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text:
//               "\\(K_{4}\\left\\lbrack Fe(CN)_{6} \\right\\rbrack\\ (dissociation = 50\\%)\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "\\(AlCl_{3}\\ (dissociation = 70\\%)\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "\\(CaF_{2}\\ (dissociation = 80\\%)\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "\\(NaCl\\ (dissociation = 90\\%)\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4573,
//         ques_no: 7,
//         ques_type: 1,
//         question_text: "\\(PbI_{4}\\) does not exist because ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:42",
//         options: [
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "\\(I^{-}\\) is better oxidising agent",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text: "\\(Pb^{4 +}\\) is more stable than \\(Pb^{2 +}\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "No sufficient energy is available to unpair 6s{2}",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "\\(Pb^{2 +}\\) is more stable than \\(Pb^{4 +}\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4574,
//         ques_no: 8,
//         ques_type: 1,
//         question_text:
//           "The increasing order of the reactivity of the following compounds towards electrophilic aromatic substitution reaction is: (I) imgsrc=https://dseinfotech.s3.amazonaws.com/QID4574_IMG1_image4.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=bf4fbf6b756a5aa78054a67855eff09a8d85ab3c80d467e224543b76289e8b85 imgsrc=https://dseinfotech.s3.amazonaws.com/QID4574_IMG2_image1.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=d839bc2019737f62cc5f6064fc781e92995447a5c8bf0f0944398e6e92dcc22b (II) imgsrc=https://dseinfotech.s3.amazonaws.com/QID4574_IMG3_image5.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=23d95f90bbd4ee903cf8a251a7893d44f5452c132537bc6ffa5465a5a9b68476 (III) imgsrc=https://dseinfotech.s3.amazonaws.com/QID4574_IMG4_image2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=7249c845574c6cd484289eff203e8ecbfc3440284de6a062fce2a09766b90d9d (IV) imgsrc=https://dseinfotech.s3.amazonaws.com/QID4574_IMG5_image6.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=d663a14c22a02d85d6aeed19c7f018f5ffd571a65468d8ad84ca8cc41a2f1dbe imgsrc=https://dseinfotech.s3.amazonaws.com/QID4574_IMG6_image3.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=86274951a4162f55151bdcfbbf3d1f31bc5c1cc2a01ecb01e551ed8698428440 ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:42",
//         options: [
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text: "I &lt; III &lt; IV &lt; II",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "III &lt; I &lt; II &lt; IV",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "III &lt; II &lt; I &lt; IV",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "III &lt; I &lt; IV &lt; II",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4575,
//         ques_no: 9,
//         ques_type: 1,
//         question_text:
//           "Which compound is least reactive towards \\(S_{N}1\\) reaction with aqueous \\(KOH\\)? ",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:47",
//         options: [
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text:
//               "imgsrc=https://dseinfotech.s3.amazonaws.com/QID4575_OPT1_image1.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=c5158c17c2d762e2b96bf6897aa24c2ee0b3a42df5a6bae73295f49cfe10c427 imgsrc=https://dseinfotech.s3.amazonaws.com/QID4575_OPT1_image5.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=5d5b652d17d06154fe8961a07a28baea3e9dde39b017cf58495f82042d014c09",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text:
//               "imgsrc=https://dseinfotech.s3.amazonaws.com/QID4575_OPT3_image3.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=0b802be1e6f73a613de3385dcd45b985b9ee29f1f1697162519bf4b7565a00ab imgsrc=https://dseinfotech.s3.amazonaws.com/QID4575_OPT3_image6.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=d92bdbb05ec9aaccdc837bf2be0762d655e71c1d7770e194c9767a30c943db79",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text:
//               "imgsrc=https://dseinfotech.s3.amazonaws.com/QID4575_OPT2_image7.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=32d20a88454f7aa2deb00d326835d6a16aed0611342a2832fbb7298c9be8705b",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "\\(\\left( CH_{3} \\right)_{2}CH - Cl\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4576,
//         ques_no: 10,
//         ques_type: 1,
//         question_text:
//           "Let \\(x = 4\\)be a directrix to an ellipse whose centre is at the origin and its eccentricity is \\(\\frac{1}{2}\\). If \\(P(1,\\beta),\\beta &gt; 0\\) is a point on this ellipse, then the equation of the normal to it at P is",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:51",
//         options: [
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text: "\\(4x - 3y = 2\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "\\(4x - 2y = 1\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "\\(8x - 2y = 5\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "\\(7x - 4y = 1\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//       {
//         question_id: 4577,
//         ques_no: 11,
//         ques_type: 1,
//         question_text:
//           "If the normal to the ellipse \\(3x^{2} + 4y^{2} = 12\\)at a point P on it is parallel to the line \\(2x + y = 4\\)and the tangent to the ellipse at P passes through \\(Q(4,4)\\) then PQ is equal to",
//         status: 1,
//         initial_reviewed_by: "0",
//         initial_reviewed_on: "2024-12-10T19:08:51",
//         options: [
//           {
//             option_no: 2,
//             option_bool_type: 0,
//             option_text: "\\(\\frac{\\sqrt{221}}{2}\\)",
//             option_correct_flag: 1,
//             option_weightage: 1,
//           },
//           {
//             option_no: 3,
//             option_bool_type: 0,
//             option_text: "\\(\\frac{\\sqrt{157}}{2}\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 1,
//             option_bool_type: 0,
//             option_text: "\\(\\frac{\\sqrt{61}}{2}\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//           {
//             option_no: 4,
//             option_bool_type: 0,
//             option_text: "\\(\\frac{5\\sqrt{5}}{2}\\)",
//             option_correct_flag: 0,
//             option_weightage: 1,
//           },
//         ],
//         tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//       },
//     ],
//     // Add other questions here
//   ];

//   // Store the data in local storage
//   localStorage.setItem("questionsData", JSON.stringify(questionsData));

//   // To retrieve the data later
//   const storedData = JSON.parse(localStorage.getItem("questionsData"));
//   console.log(storedData);
//   const [imageData, setImageData] = useState([]);

//   useEffect(() => {
//     const storedImageData = JSON.parse(localStorage.getItem("imageData")) || [];
//     setImageData(storedImageData);
//   }, []);

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImageData = [];

//     files.forEach((file) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         newImageData.push({ name: file.name, data: reader.result });
//         if (newImageData.length === files.length) {
//           const updatedImageData = [...imageData, ...newImageData];
//           localStorage.setItem("imageData", JSON.stringify(updatedImageData));
//           setImageData(updatedImageData);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const dataURLToFile = (dataURL, filename) => {
//     const arr = dataURL.split(",");
//     const mime = arr[0].match(/:(.*?);/)[1];
//     const bstr = atob(arr[1]);
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);
//     while (n--) {
//       u8arr[n] = bstr.charCodeAt(n);
//     }
//     return new File([u8arr], filename, { type: mime });
//   };

//   const handleSendImages = async () => {
//     const formData = new FormData();
//     imageData.forEach((image, index) => {
//       const file = dataURLToFile(image.data, image.name);
//       formData.append(`image${index}`, file);
//     });

//     // Log the FormData entries
//     for (let pair of formData.entries()) {
//       console.log(pair[0] + ": " + pair[1].name); // Logs the field name and file name
//     }

//     try {
//       const response = await fetch("YOUR_API_ENDPOINT", {
//         method: "POST",
//         body: formData,
//       });
//       const result = await response.json();
//       console.log(result);
//     } catch (error) {
//       console.error("Error sending images:", error);
//     }
//   };

//   return (
//     <div>
//       <input type="file" multiple onChange={handleImageUpload} />
//       <button onClick={handleSendImages}>Send Images</button>
//       <div>
//         {imageData.map((image, index) => (
//           <img
//             key={index}
//             src={image.data}
//             alt={`Stored ${index}`}
//             style={{ width: "100px", margin: "10px" }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MultipleImageStorage;

// import React, { useState, useEffect } from "react";

// const MultipleImageStorage = () => {
//   const questionsData = [
//     {
//       question_id: 4567,
//       ques_no: 1,
//       ques_type: 1,
//       question_text:
//         "Which imgsrc=https://dseinfotech.s3.amazonaws.com/QID4567_IMG1_image1.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=b3ffa729e93912da598c611b485733d35feb660625ff69e42032e33bf793ae7f alcohol is most reactive imgsrc=https://dseinfotech.s3.amazonaws.com/QID4567_IMG2_image2.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=5f83ab0a8a92feddfde559ddf15961357193b2c09d2008031696bcb3014673b6 in esterification reaction imgsrc=https://dseinfotech.s3.amazonaws.com/QID4567_IMG3_image3.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241211%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241211T085026Z&X-Amz-Expires=100&X-Amz-SignedHeaders=host&X-Amz-Signature=b46d593d989ba95f72ae9925ae1179efa30a0eb25ee2057c498c5d922ddc959c ? ",
//       status: 1,
//       initial_reviewed_by: "0",
//       initial_reviewed_on: "2024-12-10T19:08:38",
//       options: [
//         {
//           option_no: 3,
//           option_bool_type: 0,
//           option_text:
//             "\\(\\begin{matrix} CH_{3\\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ } \\\\ |\\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\ \\  \\\\ CH_{3} - CH - CH_{2} - OH \\end{matrix}\\)",
//           option_correct_flag: 0,
//           option_weightage: 1,
//         },
//         {
//           option_no: 2,
//           option_bool_type: 0,
//           option_text: "\\(CH_{3}CH_{2}OH\\)",
//           option_correct_flag: 1,
//           option_weightage: 1,
//         },
//         {
//           option_no: 1,
//           option_bool_type: 0,
//           option_text: "\\(CH_{3}OH\\ \\)",
//           option_correct_flag: 1,
//           option_weightage: 1,
//         },
//         {
//           option_no: 4,
//           option_bool_type: 0,
//           option_text: "\\(\\left( CH_{3} \\right)_{3}C - OH\\)",
//           option_correct_flag: 0,
//           option_weightage: 1,
//         },
//       ],
//       tags: [{ tag_id: 1, tag_value_id: 0, tag_name: "Test Tag" }],
//     },
//     // Add other questions here
//   ];

//   // Store the data in local storage
//   localStorage.setItem("questionsData", JSON.stringify(questionsData));

//   // To retrieve the data later
//   const storedData = JSON.parse(localStorage.getItem("questionsData"));
//   console.log(storedData);

//   const [imageData, setImageData] = useState([]);

//   useEffect(() => {
//     const storedImageData = JSON.parse(localStorage.getItem("imageData")) || [];
//     setImageData(storedImageData);
//   }, []);

//   const handleImageUpload = (event) => {
//     const files = Array.from(event.target.files);
//     const newImageData = [];

//     files.forEach((file) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         newImageData.push({ name: file.name, data: reader.result });
//         if (newImageData.length === files.length) {
//           const updatedImageData = [...imageData, ...newImageData];
//           localStorage.setItem("imageData", JSON.stringify(updatedImageData));
//           setImageData(updatedImageData);
//         }
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const dataURLToFile = (dataURL, filename) => {
//     const arr = dataURL.split(",");
//     const mime = arr[0].match(/:(.*?);/)[1];
//     const bstr = atob(arr[1]);
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);
//     while (n--) {
//       u8arr[n] = bstr.charCodeAt(n);
//     }
//     return new File([u8arr], filename, { type: mime });
//   };

//   const handleSendImages = async () => {
//     const formData = new FormData();
//     imageData.forEach((image, index) => {
//       const file = dataURLToFile(image.data, image.name);
//       formData.append(`image${index}`, file);
//     });

//     // Log the FormData entries
//     for (let pair of formData.entries()) {
//       console.log(pair[0] + ": " + pair[1].name); // Logs the field name and file name
//     }

//     try {
//       const response = await fetch("YOUR_API_ENDPOINT", {
//         method: "POST",
//         body: formData,
//       });
//       const result = await response.json();
//       console.log(result);
//     } catch (error) {
//       console.error("Error sending images:", error);
//     }
//   };

//   return (
//     <div>
//       <input type="file" multiple onChange={handleImageUpload} />
//       <button onClick={handleSendImages}>Send Images</button>
//       <div>
//         {imageData.map((image, index) => (
//           <img
//             key={index}
//             src={image.data}
//             alt={`Stored ${index}`}
//             style={{ width: "100px", margin: "10px" }}
//           />
//         ))}
//       </div>
//       <div>
//         {storedData.map((question, qIndex) => (
//           <div key={qIndex} style={{ marginBottom: "20px" }}>
//             <h3>Question {question.ques_no}: {question.question_text}</h3>
//             <ul>
//               {question.options.map((option, oIndex) => (
//                 <li key={oIndex}>
//                   {option.option_text} (Correct: {option.option_correct_flag ? "Yes" : "No"})
//                 </li>
//               ))}
//             </ul>
//             <div>
//               Tags: {question.tags.map(tag => tag.tag_name).join(", ")}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MultipleImageStorage;
// import React from "react";
// import DynamicImageRenderer from "./dynamicImageRender";

// const App = () => {
//   const imgSrc =
//     "https://dseinfotech.s3.amazonaws.com/QID8019_IMG1_image1.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUFB5JPBWXZQVSMVD%2F20241220%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20241220T103727Z&X-Amz-Expires=21600&X-Amz-SignedHeaders=host&X-Amz-Signature=b4c5e63196688135a8758aadd1bd59970dded92aa6b358a38c608143474531f5";

//   return (
//     <div>
//       <h1>Dynamic Image Renderer</h1>
//       <DynamicImageRenderer imgSrcString={imgSrc} />
//     </div>
//   );
// };

// export default App;

// import React, { useState } from "react";

// const ImageStorage = () => {
//   const [images, setImages] = useState([]); // For displaying retrieved images
//   const [selectedFiles, setSelectedFiles] = useState([]); // For storing selected files

//   // Handle file selection for multiple images
//   const handleFileChange = (event) => {
//     const files = event.target.files;
//     const fileArray = Array.from(files);

//     fileArray.forEach((file) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64String = reader.result;
//         const existingImages = JSON.parse(localStorage.getItem("imagesPOP")) || [];
//         localStorage.setItem(
//           "imagesPOP",
//           JSON.stringify([...existingImages, { name: file.name, src: base64String }]) // Store images with name and src
//         );
//       };
//       reader.readAsDataURL(file); // Convert file to Base64
//     });

//     setSelectedFiles(fileArray); // Set selected files for display
//   };

//   // Retrieve images from local storage
//   const retrieveImages = () => {
//     const storedImages = JSON.parse(localStorage.getItem("imagesPOP"));
//     if (storedImages && storedImages.length > 0) {
//       setImages(storedImages); // Set images state with the retrieved array
//     } else {
//       alert("No images found in local storage.");
//     }
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Store, Retrieve, and Send Multiple Images</h2>

//       <input type="file" accept="image/*" multiple onChange={handleFileChange} />
//       <button onClick={retrieveImages} style={{ marginLeft: "10px" }}>
//         Retrieve Images
//       </button>

//       {images.length > 0 && (
//         <div style={{ marginTop: "20px" }}>
//           <h3>Retrieved Images:</h3>
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
//             {images.map((img, index) => (
//               <div key={index} style={{ textAlign: "center" }}>
//                 <img
//                   src={img.src}
//                   alt={img.name}
//                   style={{ width: "100px", height: "auto", marginBottom: "5px" }}
//                 />
//                 <p style={{ fontSize: "12px", wordBreak: "break-word" }}>{img.name}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ImageStorage;

// import React, { useState } from 'react';
// import axios from 'axios';

// const FileUploadWithPut = () => {
//   const [file, setFile] = useState(null);

//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]); // Store the selected file in state
//   };

//   const handleSubmit = async () => {
//     const url = 'https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/parse-questions/1397';
//     const token = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzaWRkaGFydGgiLCJleHAiOjE3MzY2MTU1MjF9.lUX7fZ29AOeAxbA25iPXVXgMIvHraGoSUUguvzyOvg0';

//     // Create form data
//     const formData = new FormData();
//     formData.append('username', 'viraj');

//     // Add question list
//     const quesList = [
//       {
//         parse_ques_set_question_id: 7872,
//         parse_ques_set_id: null,
//         parse_ques_set_ques_no: 2,
//         parse_ques_set_ques_type: 1,
//         question_text: 'shashi',
//         status: 2,
//         initial_reviewed_by: null,
//         initial_reviewed_on: '2024-12-24T07:08:46.311Z',
//       },
//     ];
//     formData.append('ques_list', JSON.stringify(quesList));

//     // Add options list
//     const optionsList = [
//       {
//         parse_ques_set_option_id: 29720,
//         parse_ques_set_id: null,
//         parse_ques_set_question_id: null,
//         parse_ques_option_no: 1,
//         parse_ques_option_bool_type: 1,
//         parse_ques_option_text: 'viraj',
//         parse_ques_option_correct_flag: 1,
//         parse_ques_option_weightage: 1,
//       },
//     ];
//     formData.append('parse_ques_set_options_list', JSON.stringify(optionsList));

//     // Add tagging list
//     const taggingList = [
//       {
//         parse_ques_set_id: null,
//         parse_ques_set_question_id: null,
//         parse_ques_tag_id: 1,
//         parse_ques_tag_value_id: 1,
//       },
//     ];
//     formData.append('parse_ques_tagging_list', JSON.stringify(taggingList));

//     // Append file (if selected)
//     if (file) {
//       formData.append('files', file, file.name);
//     }

//     try {
//       const response = await axios.put(url, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           Authorization: token,
//         },
//       });

//       console.log('Response:', response.data);
//       alert('File and data uploaded successfully!');
//     } catch (error) {
//       console.error('Error:', error.response ? error.response.data : error.message);
//       alert('Failed to upload file and data');
//     }
//   };

//   return (
//     <div>
//       <h2>Upload File and Send PUT Request</h2>
//       <input type="file" onChange={handleFileChange} />
//       <button onClick={handleSubmit}>Submit</button>
//     </div>
//   );
// };

// export default FileUploadWithPut;

// import React from 'react'
// import React, { useState } from "react";
// import axios from "axios";

// const GenerateOtp = () => {
//   const [mobileNumber, setMobileNumber] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   const handleGenerateOtp = async () => {
//     if (!mobileNumber) {
//       setMessage("Please enter a valid mobile number.");
//       return;
//     }

//     setLoading(true);
//     setMessage("");

//     try {
//       const response = await axios.post(
//         `https://prism-dev.dse-cc-api.com/prism/api/v1/generate-otp-send-sms?mob_number=${mobileNumber}`,
//         {},
//         {
//           headers: {
//             "Content-Type": "application/json",
//             device_type: "iOS",
//             device_model: "iPhone6pro",
//             platform: "mobile",
//             network_ip: "98.207.254.136", // Replace with actual IP
//             allow_location_permission: "true",
//             location: "3333333,444444", // Add if available
//           },
//         }
//       );

//       if (response.status === 200) {
//         setMessage("OTP sent successfully!");
//       } else {
//         setMessage("Failed to send OTP. Try again.");
//       }
//     } catch (error) {
//       setMessage("Error sending OTP. Please try again later.");
//       console.error("API Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="otp-container">
//       <h2>Generate OTP</h2>
//       <input
//         type="text"
//         placeholder="Enter mobile number"
//         value={mobileNumber}
//         onChange={(e) => setMobileNumber(e.target.value)}
//       />
//       <button onClick={handleGenerateOtp} disabled={loading}>
//         {loading ? "Sending..." : "Generate OTP"}
//       </button>
//       {message && <p>{message}</p>}
//     </div>
//   );
// };

// export default GenerateOtp;

// import { useLocation } from "react-router-dom";
// import { v4 as uuidv4 } from "uuid";
// import CustomSearchDropdown from "../../Reports/components/FieldsComponent";
// import "./ReviewQuestion.css";
// import ReviewComponent from "./ReviewComponent";
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { fetchCourseData } from "./../../../Redux/StudentRegistration/courseSlice";
// import { API_BASE_URL } from "../../../Config/Config";
// import AddOptionDropdwon from "../ParseBulkQuestions/AddDropdownOptions";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import minusImgClose from "./../../../Assets/Images/CommanImages/MinusGrey.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import DropDownUP from "../ParseBulkQuestions/Dropdown";
// import DropDownUP2 from "../ParseBulkQuestions/DropdownUP2";
// import DropDown from "./coursedrodpwonRQ";
// // import DropDownMN from "../../../Components/Shared/Dropdown/Dropdown";
// import DropDownMN from "./DrodpwonRQDynamic";
// import katex from "katex";
// import "katex/dist/katex.min.css";
// import pencil from "../../../Assets/Images/CommanImages/GPenz.png";
// import UndoBack from "../../../Assets/Images/CommanImages/Reset.png";
// import TestComponent from "./testReviewComponent";

// const ReviewQuestion = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   useEffect(() => {
//     if (dataClient) {
//       const userName =
//         dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId =
//         dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

//       // Store values in sessionStorage
//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);
//   const userName =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
//     sessionStorage.getItem("user_name") ||
//     "";

//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
//     sessionStorage.getItem("clientBranchId") ||
//     null;

//   const clientId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
//     sessionStorage.getItem("clientId") ||
//     null;

//   const clearReviewData = () => {
//     const keysToClear = ["POP", "NON", "TagsPOP", "ImagesPOP"];

//     keysToClear.forEach((key) => {
//       localStorage.removeItem(key);
//     });

//     console.log(" Cleared local storage data on page load:", keysToClear);
//   };

//   // 🔹 Run when the page loads
//   useEffect(() => {
//     clearReviewData();
//   }, []); // Empty dependency array → runs **only once** when the component mounts

//   const [checkedTags, setCheckedTags] = useState({}); // State to store checkbox states
//   const [refreshQuestions, setRefreshQuestions] = useState(false);
//   const [errorCount, setErrorCount] = useState(0);
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const setId = queryParams.get("setId");
//   const setNameSet = queryParams.get("setName");
//   const imageFiles = [];
//   const { coursesdata = [] } = useSelector((state) => state.course);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [selectedCourseLabel, setSelectedCourseLabel] = useState("");
//   const [selectedDifficultyLevelLabel, setSelectedDifficultyLevelLabel] =
//     useState("");
//   const [globalImageCounter, setGlobalImageCounter] = useState(0); // Global image counter
//   const [selectedSetName, setSelectedSetName] = useState(null);
//   const [selectedSetId, setSelectedSetId] = useState(setId); // Store selected ID
//   const [setNames, setSetNames] = useState([]); // Dropdown options
//   //  const  DeleteQuestion = useState(deletedQuestions);
//   const [convertedHtml, setConvertedHtml] = useState("");
//   const [isEditing, setIsEditing] = useState(false); // Tracks if the user is editing
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [currentQuestion, setCurrentQuestion] = useState(null);
//   const [selected, setSelected] = useState([]);
//   const [showTwoInputs, setShowTwoInputs] = useState(false);
//   const toggleView = () => setShowTwoInputs(!showTwoInputs);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   // const { coursesdata } = useSelector((state) => state.course);
//   const [isSectionVisible, setIsSectionVisible] = useState(true); // State to toggle visibility
//   const [deletedQuestions, setDeletedQuestions] = useState([]);
//   const [questionsData, setQuestionsData] = useState([]);
//   const [isOpenTagging, setIsOpenTagging] = useState(true);
//   const [isOpenUpload, setIsOpenUpload] = useState(true);
//   // const [subjects, setSubjects] = useState([]);
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   // const [chapters, setChapters] = useState([]);
//   const [selectedChapter, setSelectedChapter] = useState(null);
//   // const [topics, setTopics] = useState([]);
//   const [selectedTopic, setSelectedTopic] = useState(null);
//   const [tags, setTags] = useState([]);
//   const [dropdownData, setDropdownData] = useState({});
//   const [value, setValues] = useState({ course_id: "" });
//   const [uploadedFile, setUploadedFile] = useState(null);
//   const [dropdownKey, setDropdownKey] = useState(Date.now());
//   const [selectedSubjectLabel, setSelectedSubjectLabel] = useState(""); // Add this line
//   const [selectedChapterLabel, setSelectedChapterLabel] = useState("");
//   const [selectedTopicLabel, setSelectedTopicLabel] = useState("");
//   const [topicId, setTopicId] = useState(null);
//   const accessToken = localStorage.getItem("other");
//   const toggleSectionVisibility = () => {
//     setIsSectionVisible((prev) => !prev); // Toggle the visibility state
//   };
//   const [selectedPYQLabel, setSelectedPYQLabel] = useState(""); // For PYQ Dropdown
//   const [selectedTestTagLabel, setSelectedTestTagLabel] = useState(""); // For Test Tag Dropdown
//   const [selectedImportantLabel, setSelectedImportantLabel] = useState(""); // For Important Dropdown

//   const handlePreviousButtonClick = () => {
//     if (currentQuestion) {
//       const currentIndex = questionsData.findIndex(
//         (question) => question.question_id === currentQuestion.question_id
//       );
//       if (currentIndex > 0) {
//         setCurrentQuestion(questionsData[currentIndex - 1]);
//       }
//     }
//     setIsEditMode(false); // Ensure the mode is set to non-editable
//     setShowTwoInputs(false); // Ensure edit inputs are hidden
//   };

//   const clearLocalStorage = () => {
//     const keysToClear = [
//       "POP",
//       "NON",
//       "TagsPOP",
//       "ImagesPOP",
//       "DeletePush",
//       "TagsMain",
//     ]; // List of keys you want to remove
//     const popData = localStorage.getItem("POP"); // Retrieve the data from the "POP" key

//     if (popData) {
//       // Create a Blob with the POP data
//       const blob = new Blob([popData], { type: "text/plain" });
//       const url = URL.createObjectURL(blob);

//       // Create a temporary anchor element to trigger the download
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = "Question_Not_Send_Data.txt"; // Set the file name

//       // Add an event listener to clear local storage after the download is triggered
//       a.addEventListener("click", () => {
//         // Wait for a small delay to ensure the file is saved before clearing localStorage
//         setTimeout(() => {
//           keysToClear.forEach((key) => {
//             localStorage.removeItem(key);
//           });

//           // Set the UI updates and messages
//           setIsMessageBoxVisible(true);
//           setMessageBox(
//             <div className="Container-messageBOX">
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <p style={{ marginLeft: "20px", marginTop: "4px" }}>
//                   Cleared Faulty Values.
//                 </p>
//               </div>
//               <div className="messagebox-insider2"></div>
//             </div>
//           );
//           setActiveImg(ErrorImg);
//         }, 100); // Adjust the delay as needed
//       });

//       document.body.appendChild(a); // Append the anchor to the body
//       a.click(); // Trigger the download
//       document.body.removeChild(a); // Clean up the anchor element
//       URL.revokeObjectURL(url); // Revoke the object URL to free memory
//     } else {
//       // If no POP data exists, clear local storage immediately
//       keysToClear.forEach((key) => {
//         localStorage.removeItem(key);
//       });

//       // Set the UI updates and messages
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <p style={{ marginLeft: "20px", marginTop: "4px" }}>
//               Cleared Faulty Values.
//             </p>
//           </div>
//           <div className="messagebox-insider2"></div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//     }
//   };

//   const handleImageClick = () => {
//     setIsEditMode(!isEditMode);
//     setCurrentQuestion(currentQuestion);
//     toggleView();
//   };

//   useEffect(() => {
//     // Initialize the counter based on existing images in localStorage
//     const storedImages = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
//     let maxCounter = 0;

//     // Find the highest image number across all questions
//     Object.values(storedImages).forEach((images) => {
//       images.forEach((img) => {
//         const match = img.name.match(/image(\d+)\.png/);
//         if (match) {
//           const number = parseInt(match[1], 10);
//           if (number > maxCounter) maxCounter = number;
//         }
//       });
//     });

//     setGlobalImageCounter(maxCounter);
//   }, []);

//   useEffect(() => {
//     if (selectedSetId) {
//       const fetchQuestionsData = async () => {
//         try {
//           const response = await fetch(
//             `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parsed-questions/?client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_id=${selectedSetId}`,
//             {
//               method: "GET",
//               headers: {
//                 accept: "application/json",
//                 Authorization: `Bearer ${sessionStorage.getItem("other")}`,
//               },
//             }
//           );

//           //  Ensure response is OK before parsing
//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }

//           const data = await response.json();

//           //  Ensure data is an array before setting state
//           if (Array.isArray(data) && data.length > 0) {
//             setQuestionsData(data);

//             const popData = JSON.parse(localStorage.getItem("POP")) || {};
//             const nonData = JSON.parse(localStorage.getItem("NON")) || {};
//             const firstQuestion = data[0];

//             //  Check if first question exists in local storage
//             if (popData[firstQuestion.question_id]) {
//               setCurrentQuestion({
//                 ...firstQuestion,
//                 question_text: popData[firstQuestion.question_id].question_text,
//                 options: popData[firstQuestion.question_id].options,
//               });
//             } else if (nonData[firstQuestion.question_id]) {
//               setCurrentQuestion({
//                 ...firstQuestion,
//                 question_text: nonData[firstQuestion.question_id].question_text,
//                 options: nonData[firstQuestion.question_id].options,
//               });
//             } else {
//               setCurrentQuestion(firstQuestion);
//             }
//           } else {
//             console.warn("No questions returned from API.");
//             setQuestionsData([]); //  Ensure empty state is handled
//             setCurrentQuestion(null); //  Reset current question
//           }
//         } catch (error) {
//           console.error("Error fetching questions data:", error);
//         }
//       };

//       fetchQuestionsData();
//     }
//   }, [selectedSetId, refreshQuestions]);

//   const handleLatexChange = (event) => {
//     const newLatex = event.target.value;
//     setConvertedHtml(katex.renderToString(newLatex, { throwOnError: false }));
//   };

//   const handleButtonClick = (question) => {
//     if (!isEditMode) {
//       console.log("Navigating to question:", question.question_id);

//       let loadedQuestion = question;

//       setCurrentQuestion({
//         ...question,
//         question_text: loadedQuestion.question_text,
//         options: loadedQuestion.options,
//       });
//     }
//   };

//   const processText = (text) => {
//     // Replace imgsrc with <img> tags
//     text = text.replace(
//       /imgsrc=([^ ]+)/g,
//       '<img src="$1" class="Img-RQ-QnsAns" alt="image" />'
//     );

//     // Render LaTeX expressions
//     const latexInlineRegex = /\\\((.*?)\\\)/g; // For \( ... \)
//     const latexBlockRegex = /\\\[(.*?)\\\]/g; // For \[ ... \]

//     // Process inline LaTeX expressions
//     text = text.replace(latexInlineRegex, (match, p1) => {
//       return katex.renderToString(p1, { throwOnError: false });
//     });

//     // Process block LaTeX expressions
//     text = text.replace(latexBlockRegex, (match, p1) => {
//       return katex.renderToString(p1, {
//         throwOnError: false,
//         displayMode: true, // Render in display mode for block expressions
//       });
//     });

//     return text;
//   };

//   const [submittedQuestions, setSubmittedQuestions] = useState([]);
//   const [reviewedQuestions, setReviewedQuestions] = useState([]);

//   const getButtonClass = (question) => {
//     let classes = [];
//     const popData = JSON.parse(localStorage.getItem("POP")) || {}; //  Check stored reviewed questions in POP
//     const nonData = JSON.parse(localStorage.getItem("NON")) || {}; //  Check stored reviewed questions in NON
//     const reviewedData =
//       JSON.parse(localStorage.getItem("reviewedQuestions")) || []; //  Local cache of reviewed questions

//     if (
//       popData[question.question_id] ||
//       nonData[question.question_id] ||
//       reviewedData.includes(question.question_id)
//     ) {
//       classes.push("blue-review-parser"); //  Always mark reviewed questions blue
//     } else if (submittedQuestions.includes(question.question_id)) {
//       classes.push("grey-submitted-parser");
//     } else if (deletedQuestions.includes(question.question_id)) {
//       classes.push("Delete_button_overlap_RQ");
//     } else {
//       switch (question.status) {
//         case 4:
//           classes.push("grey-submitted-parser");
//           break;
//         case 2:
//           classes.push("blue-review-parser"); //  Ensure reviewed questions remain blue
//           break;
//         case 3:
//           classes.push("Delete_button_overlap_RQ");
//           break;
//         case 5:
//           classes.push("Delete_button_overlap_RQ-2");
//           break;
//         default:
//           classes.push("White-Not-review-parser");
//       }
//     }

//     if (currentQuestion?.question_id === question.question_id) {
//       classes.push("current-question");
//     }

//     return classes.join(" ");
//   };

//   const handleSkipReview = () => {
//     if (!currentQuestion) return;

//     // Retrieve local storage data
//     const popData = JSON.parse(localStorage.getItem("POP")) || {};
//     const nonData = JSON.parse(localStorage.getItem("NON")) || {};
//     const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || {};

//     // Remove question from local storage
//     let modified = false;
//     if (popData[currentQuestion.question_id]) {
//       delete popData[currentQuestion.question_id];
//       localStorage.setItem("POP", JSON.stringify(popData));
//       modified = true;
//     }
//     if (nonData[currentQuestion.question_id]) {
//       delete nonData[currentQuestion.question_id];
//       localStorage.setItem("NON", JSON.stringify(nonData));
//       modified = true;
//     }
//     if (tagsData[currentQuestion.question_id]) {
//       delete tagsData[currentQuestion.question_id];
//       localStorage.setItem("TagsPOP", JSON.stringify(tagsData));
//       modified = true;
//     }

//     console.log(
//       `Skipped review: Removed question ${currentQuestion.question_id} from POP/NON/Tags`,
//       modified
//     );

//     // **Update the reviewedQuestions state to remove the skipped question**
//     setReviewedQuestions((prevReviewed) =>
//       prevReviewed.filter((id) => id !== currentQuestion.question_id)
//     );

//     // **Ensure Status Change Triggers Button Color Update**
//     setQuestionsData((prevQuestions) => {
//       const updatedQuestions = prevQuestions.map((q) =>
//         q.question_id === currentQuestion.question_id
//           ? { ...q, status: 1 } // Change status to 1 (not reviewed)
//           : q
//       );
//       return [...updatedQuestions]; // Return a new array to trigger re-render
//     });

//     // Move to the next question
//     const nextIndex =
//       questionsData.findIndex(
//         (q) => q.question_id === currentQuestion.question_id
//       ) + 1;

//     if (nextIndex < questionsData.length) {
//       setCurrentQuestion(questionsData[nextIndex]);
//     } else {
//       console.log("No more questions left.");
//     }

//     // Reset UI states
//     setIsEditMode(false);
//     setShowTwoInputs(false);
//   };

//   const handleDeleteQuestion = () => {
//     if (currentQuestion) {
//       const deletePushData =
//         JSON.parse(localStorage.getItem("DeletePush")) || {};

//       if (deletedQuestions.includes(currentQuestion.question_id)) {
//         // Restore question
//         setDeletedQuestions(
//           deletedQuestions.filter((id) => id !== currentQuestion.question_id)
//         );
//         delete deletePushData[currentQuestion.question_id]; // Remove from DeletePush
//       } else {
//         // Delete question
//         setDeletedQuestions([...deletedQuestions, currentQuestion.question_id]);

//         // Prepare question data for DeletePush
//         const deletedQuestionData = {
//           parse_ques_set_question_id: currentQuestion.question_id,
//           parse_ques_set_id: selectedSetId,
//           parse_ques_set_ques_no: currentQuestion.ques_no,
//           parse_ques_set_ques_type: currentQuestion.ques_type,
//           question_text: currentQuestion.question_text,
//           status: 3, // Default status for delete action
//           initial_reviewed_by: userName,
//           initial_reviewed_on: new Date().toISOString(),
//           options: currentQuestion.options.map((option, index) => ({
//             parse_ques_set_option_id: option.option_id,
//             parse_ques_set_id: selectedSetId,
//             parse_ques_set_question_id: currentQuestion.question_id,
//             parse_ques_option_no: option.option_no || index + 1,
//             parse_ques_option_bool_type: option.option_bool_type,
//             option_text: option.option_text,
//             parse_ques_option_correct_flag: option.option_correct_flag,
//             parse_ques_option_weightage: option.option_weightage,
//           })),
//         };

//         deletePushData[currentQuestion.question_id] = deletedQuestionData;
//         localStorage.setItem("DeletePush", JSON.stringify(deletePushData));
//       }
//     }
//   };

//   useEffect(() => {
//     dispatch(fetchCourseData());
//     fetchTags();
//   }, [dispatch]);

//   useEffect(() => {
//     const fetchSetNames = async () => {
//       try {
//         const token = sessionStorage.getItem("other");
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parse-ques-set-all/`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         if (response.ok) {
//           const formattedSetNames = data.data.map((item) => ({
//             label: item.parse_ques_set_name,
//             id: item.parse_ques_set_id,
//           }));
//           setSetNames(formattedSetNames);
//         } else {
//           console.error("Failed to fetch set names:", data.message);
//         }
//       } catch (error) {
//         console.error("Error while fetching set names:", error);
//       }
//     };
//     fetchSetNames();
//   }, []);

//   const fetchTags = async () => {
//     try {
//       const token = sessionStorage.getItem("other");
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parse-tags-all/`,
//         {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       const data = await response.json();
//       if (response.ok) {
//         setTags(data.data);
//       } else {
//         console.error("Error fetching tags:", data.message);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   useEffect(() => {
//     const fetchSubjects = async () => {
//       if (value.course_id) {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${value.course_id}`
//         );
//         const data = await response.json();
//         setSubjects(data);
//         setSelectedSubjectLabel(""); // Reset the subject label
//         setSelectedChapterLabel(""); // Reset the chapter label
//         setSelectedTopicLabel(""); // Reset the topic label
//         setTopicId(null); // Reset the topic ID
//       }
//     };

//     fetchSubjects();
//   }, [value.course_id]);

//   useEffect(() => {
//     const fetchChapters = async () => {
//       if (selectedSubject) {
//         try {
//           const response = await fetch(
//             `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapters-by-subject/?subject_id=${selectedSubject}`
//           );
//           const chapterData = await response.json();
//           setChapters(chapterData); // Update chapters list
//           setSelectedChapterLabel(""); // Reset chapter label on subject change
//           setSelectedChapter(null); // Clear chapter selection
//           setTopics([]); // Clear topics when a new subject is selected
//           setSelectedTopicLabel(""); // Reset topic label
//           setTopicId(null); // Clear topic selection
//         } catch (error) {
//           console.error("Error fetching chapters:", error);
//         }
//       }
//     };

//     fetchChapters();
//   }, [selectedSubject]); // Fetch chapters when selectedSubject changes

//   useEffect(() => {
//     if (selectedChapter) {
//       fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-topics-by-chapter/?chapter_id=${selectedChapter}`
//       )
//         .then((response) => response.json())
//         .then((topicData) => {
//           setTopics(topicData);

//           // Ensure that the topic value exists in the new chapter's topic list
//           if (!topicData.some((topic) => topic.topic_id === topicId)) {
//             setTopicId(null);
//             setSelectedTopicLabel("Select Topic");
//           }
//         })
//         .catch((error) => console.error("Error fetching topics:", error));
//     }
//   }, [selectedChapter]);

//   const prepareTags = () => {
//     const selectedTags = [];

//     // Add parse_ques_set_id for all tags
//     const parseQuesSetId = selectedSetId;

//     console.log("🟢 Preparing Tags...");

//     // Process dropdown tags
//     tags
//       .filter((tag) => tag.parse_tag_type === 1)
//       .forEach((tag) => {
//         const selectedOption = dropdownData[tag.parse_tag_id]; // Get the selected option for this tag
//         if (selectedOption) {
//           selectedTags.push({
//             parse_ques_set_id: parseQuesSetId, // Include selectedSetId
//             parse_ques_set_question_id: currentQuestion.question_id,
//             parse_ques_tag_id: tag.parse_tag_id,
//             parse_ques_tag_value_id: selectedOption,
//           });
//         }
//       });

//     // Process checkbox tags
//     tags
//       .filter((tag) => tag.parse_tag_type === 2)
//       .forEach((tag) => {
//         const checkbox = document.getElementById(
//           `checkbox-${tag.parse_tag_id}`
//         );
//         if (checkbox) {
//           selectedTags.push({
//             parse_ques_set_id: parseQuesSetId, // Include selectedSetId
//             parse_ques_set_question_id: currentQuestion.question_id,
//             parse_ques_tag_id: tag.parse_tag_id,
//             parse_ques_tag_value_id: checkbox.checked ? 1 : 0, // 1 if checked, 0 otherwise
//           });
//         }
//       });

//     if (value.course_id) {
//       selectedTags.push({
//         parse_ques_set_id: parseQuesSetId, // Include selectedSetId
//         parse_ques_set_question_id: currentQuestion.question_id,
//         parse_ques_tag_id: 2,
//         parse_ques_tag_value_id: value.course_id,
//       });
//     }
//     if (selectedSubject) {
//       selectedTags.push({
//         parse_ques_set_id: parseQuesSetId, // Include selectedSetId
//         parse_ques_set_question_id: currentQuestion.question_id,
//         parse_ques_tag_id: 3,
//         parse_ques_tag_value_id: selectedSubject,
//       });
//     }
//     if (selectedChapter) {
//       selectedTags.push({
//         parse_ques_set_id: parseQuesSetId, // Include selectedSetId
//         parse_ques_set_question_id: currentQuestion.question_id,
//         parse_ques_tag_id: 4,
//         parse_ques_tag_value_id: selectedChapter,
//       });
//     }

//     if (selectedTopic) {
//       console.log(" Topic is being saved:", selectedTopic);
//       selectedTags.push({
//         parse_ques_set_id: parseQuesSetId,
//         parse_ques_set_question_id: currentQuestion.question_id,
//         parse_ques_tag_id: 5,
//         parse_ques_tag_value_id: selectedTopic,
//       });
//     } else {
//       console.warn("⚠️ Topic ID is null, not saving topic!");
//     }

//     return selectedTags;
//   };

//   const showErrorMessage = (message, fileName, content) => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{message}</span>
//         </div>
//         <div className="messagebox-insider2">
//           {fileName && content && (
//             <button
//               className="messagebox-cancel-btn"
//               onClick={() => downloadTxtFile(fileName, content)}
//             >
//               Download Error
//             </button>
//           )}
//         </div>
//       </div>
//     );
//     setActiveImg(ErrorImg);
//   };

//   const downloadTxtFile = (fileName, content) => {
//     const blob = new Blob([content], { type: "text/plain" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = fileName;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const handleUpdateQuestion = async (isSubmit = false) => {
//     try {
//       console.log("Starting update process...");

//       // Ensure required data is available before proceeding
//       const popData = JSON.parse(localStorage.getItem("POP")) || {};
//       const nonData = JSON.parse(localStorage.getItem("NON")) || {};
//       const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || [];
//       const imagesData = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
//       const deletePushData =
//         JSON.parse(localStorage.getItem("DeletePush")) || {};

//       if (!Object.keys(popData).length && !Object.keys(nonData).length) {
//         console.error("No questions data found in localStorage.");
//         showErrorMessage(
//           "No questions data to update. Please review some questions first."
//         );
//         return;
//       }

//       console.log("Preparing data for update...");

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-parse-questions/?parse_ques_set_id=${selectedSetId}`;

//       const formData = new FormData();
//       formData.append("username", userName);

//       // Combine POP and NON data
//       const mergedData = { ...nonData, ...popData };

//       Object.keys(deletePushData).forEach((questionId) => {
//         deletePushData[questionId].status = isSubmit ? 5 : 3;
//       });

//       // Prepare ques_list
//       const quesList = [
//         ...Object.keys(mergedData).map((questionId) => {
//           const questionData = mergedData[questionId];
//           const processedQuestionText = replaceImagesWithPlaceholders(
//             questionData.question_text,
//             questionId
//           );

//           questionData.options.forEach((option, index) => {
//             option.option_text = replaceImagesWithPlaceholders(
//               option.option_text,
//               `${questionId}_option_${index}`
//             );
//           });

//           return {
//             parse_ques_set_question_id: questionId,
//             parse_ques_set_id: selectedSetId,
//             parse_ques_set_ques_no: questionData.parse_ques_set_ques_no,
//             parse_ques_set_ques_type: questionData.parse_ques_set_ques_type,
//             question_text: processedQuestionText,
//             status: questionData.status,
//             initial_reviewed_by: userName,
//             initial_reviewed_on: new Date().toISOString(),
//           };
//         }),
//         ...Object.values(deletePushData), // Append deleted questions with updated status
//       ];

//       formData.append("ques_list", JSON.stringify(quesList));

//       //  Fixing parse_ques_option_no and parse_ques_option_correct_flag
//       const optionsList = Object.keys(mergedData).flatMap((questionId) => {
//         const questionData = mergedData[questionId];

//         return questionData.options.map((option, index) => {
//           const correctOptionNo =
//             option.parse_ques_option_no ?? option.option_no ?? index + 1;
//           const correctFlag =
//             option.parse_ques_option_correct_flag ?? option.option_correct_flag;
//           const optionBoolType = option.parse_ques_option_bool_type ?? 0; //  Ensure `parse_ques_option_bool_type` is always present
//           const optionWeightage =
//             option.parse_ques_option_weightage ?? option.option_weightage; //  Ensure this field is present

//           console.log(
//             ` Sending Option - QID: ${questionId}, Option No: ${correctOptionNo}, Correct Flag: ${correctFlag}`
//           );

//           return {
//             // parse_ques_set_option_id: option.parse_ques_set_option_id ?? option.option_id, //  Use existing option_id
//             // parse_ques_set_id: selectedSetId,
//             // parse_ques_set_question_id: questionId,
//             // parse_ques_option_no: correctOptionNo, //  Ensure correct option number is sent
//             // parse_ques_option_bool_type: option.parse_ques_option_bool_type,
//             // parse_ques_option_text: option.option_text,
//             // parse_ques_option_correct_flag: correctFlag, //  Ensure correct option flag is sent
//             // parse_ques_option_weightage: option.parse_ques_option_weightage,
//             parse_ques_set_option_id:
//               option.parse_ques_set_option_id ?? option.option_id,
//             parse_ques_set_id: selectedSetId,
//             parse_ques_set_question_id: questionId,
//             parse_ques_option_no: correctOptionNo,
//             parse_ques_option_bool_type: optionBoolType, //  Ensure this field is present
//             parse_ques_option_text: option.option_text,
//             parse_ques_option_correct_flag: correctFlag,
//             parse_ques_option_weightage: optionWeightage || 0, //  Ensure this field is always included
//           };
//         });
//       });

//       formData.append(
//         "parse_ques_set_options_list",
//         JSON.stringify(optionsList)
//       );

//       //  Attach `TagsPOP` data (from localStorage)
//       formData.append("parse_ques_tagging_list", JSON.stringify(tagsData));

//       // Collect and append image files
//       const imageFiles = [];
//       Object.keys(imagesData).forEach((questionId) => {
//         imagesData[questionId].forEach((img) => {
//           const blob = base64ToBlob(img.base64);
//           imageFiles.push(new File([blob], img.name, { type: blob.type }));
//         });
//       });

//       imageFiles.forEach((file) => {
//         formData.append("files", file);
//       });

//       console.log("Sending update request...");

//       const response = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Authorization: `Bearer ${sessionStorage.getItem("other")}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error("Error updating questions:", errorData);
//         setErrorCount((prevCount) => prevCount + 1); // Increment error count
//         showErrorMessage("Error while updating questions. Please try again.");
//       } else {
//         console.log(" Questions updated successfully.");
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Questions updated successfully!</span>
//             </div>
//           </div>
//         );

//         //  Clear localStorage after successful submission
//         localStorage.removeItem("POP");
//         localStorage.removeItem("NON");
//         localStorage.removeItem("TagsPOP");
//         localStorage.removeItem("ImagesPOP");
//         localStorage.removeItem("DeletePush");
//         localStorage.removeItem("TagsMain");

//         navigate(-2);
//       }
//     } catch (error) {
//       console.error("Error while updating questions:", error);
//       setErrorCount((prevCount) => prevCount + 1); // Increment error count
//       showErrorMessage(
//         "Unexpected error occurred while updating questions. Try again."
//       );
//     }
//   };

//   const handleSubmitSelectedReview = async () => {
//     try {
//       // Prepare ques_list
//       const quesList = questionsData
//         .filter((question) => question.status === 2 || question.status === 3)
//         .map((question) => ({
//           parse_ques_set_question_id: question.question_id,
//           parse_ques_set_id: selectedSetId,
//           parse_ques_set_ques_no: question.ques_no,
//           parse_ques_set_ques_type: question.ques_type,
//           status: question.status === 2 ? 4 : 5, // Update status: 2 -> 4, 3 -> 5
//           initial_reviewed_by: userName,
//           initial_reviewed_on: new Date().toISOString(),
//         }));

//       if (quesList.length === 0) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>No reviewed questions found to submit.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//         return;
//       }

//       // Prepare parse_ques_set_options_list
//       const optionsList = questionsData.flatMap((question) =>
//         question.options.map((option) => ({
//           parse_ques_set_option_id: option.option_id,
//           parse_ques_set_id: selectedSetId,
//           parse_ques_set_question_id: question.question_id,
//           parse_ques_option_no: option.option_no || 0,
//           parse_ques_option_bool_type: option.option_bool_type || 0,
//           parse_ques_option_correct_flag: option.option_correct_flag || 0,
//           parse_ques_option_weightage: option.option_weightage || 1,
//         }))
//       );

//       // Prepare parse_ques_tagging_list
//       const taggingList = questionsData.flatMap((question) =>
//         question.tags.map((tag) => ({
//           parse_ques_set_id: selectedSetId,
//           parse_ques_set_question_id: question.question_id,
//           parse_ques_tag_id: tag.tag_id,
//           parse_ques_tag_value_id: tag.tag_value_id,
//           // parse_tag_value_id : tag.tag_value_id
//         }))
//       );

//       // Create FormData
//       const formData = new FormData();
//       formData.append("username", userName);
//       formData.append("ques_list", JSON.stringify(quesList));
//       formData.append(
//         "parse_ques_set_options_list",
//         JSON.stringify(optionsList)
//       );
//       formData.append("parse_ques_tagging_list", JSON.stringify(taggingList));

//       formData.append(
//         "files",
//         new Blob([], { type: "application/octet-stream" }),
//         ""
//       );

//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-parse-questions/?parse_ques_set_id=${selectedSetId}`;

//       // Make the API request
//       const response = await fetch(url, {
//         method: "PUT",
//         headers: {
//           Authorization: `Bearer ${sessionStorage.getItem("other")}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error("Error submitting reviewed questions:", errorData);
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 Error while submitting reviewed questions. Please try again.
//               </span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorImg);
//       } else {
//         console.log("Reviewed questions submitted successfully.");
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Reviewed questions submitted successfully!</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//         navigate(-2);
//       }
//     } catch (error) {
//       console.error("Error while submitting reviewed questions:", error);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               An unexpected error occurred while submitting reviewed questions.
//               Please try again.
//             </span>
//           </div>
//         </div>
//       );
//       setActiveImg(ErrorImg);
//     }
//   };

//   //   Which is more Reactive in nature You or Me ?  ans is this structure .
//   // Helper function to convert base64 to Blob
//   const base64ToBlob = (base64) => {
//     const byteString = atob(base64.split(",")[1]);
//     const mimeType = base64.split(",")[0].match(/:(.*?);/)[1];
//     const ab = new ArrayBuffer(byteString.length);
//     const ia = new Uint8Array(ab);
//     for (let i = 0; i < byteString.length; i++) {
//       ia[i] = byteString.charCodeAt(i);
//     }
//     return new Blob([ab], { type: mimeType });
//   };

//   const convertLatexToHTML = (latex) => {
//     return latex.replace(/\\\((.*?)\\\)/g, (match, p1) => {
//       try {
//         return katex.renderToString(p1, { throwOnError: false });
//       } catch (error) {
//         console.error("Error converting LaTeX:", error);
//         return latex; // Return raw LaTeX on error
//       }
//     });
//   };

//   const [NewDataCOA, setNewDataCOA] = useState({});

//   const fetchNewUpdatedDataValues = (newDataChild) => {
//     if (!newDataChild) {
//       console.error("No new data provided.");
//       return null;
//     }

//     if (currentQuestion) {
//       console.log(":: Updated values from child ::", newDataChild);
//       console.log(":: Current Question ID ::", currentQuestion.question_id);

//       const updatedData = {
//         QuestionIDNewDataChild: currentQuestion.question_id,
//         QuestionTextNewDataChild: newDataChild.question_text,
//         OptionTextNewDataChild: newDataChild.options,
//         ImagesNewDataChild: newDataChild.images, // Include images in updated data
//       };

//       setNewDataCOA(updatedData);

//       // Save images to localStorage
//       const existingImages =
//         JSON.parse(localStorage.getItem("ImagesPOP")) || {};
//       existingImages[currentQuestion.question_id] = newDataChild.images;
//       localStorage.setItem("ImagesPOP", JSON.stringify(existingImages));

//       console.log(":: Returning updated data ::", updatedData);
//       return updatedData;
//     } else {
//       console.error("No current question available.");
//       return null;
//     }
//   };

// const handleReviewAndProceed = () => {
//   if (!currentQuestion) return;

//   // Load existing local storage data
//   const popData = JSON.parse(localStorage.getItem("POP")) || {};
//   const nonData = JSON.parse(localStorage.getItem("NON")) || {};
//   const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || [];
//   const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};

//   // Generate updated tags for tagging
//   const updatedTags = prepareTags();

//   let questionData;

//   if (!isEditMode) {
//     // Non-Edit Mode (Untouched Questions)
//     questionData = {
//       parse_ques_set_question_id: currentQuestion.question_id,
//       parse_ques_set_id: selectedSetId,
//       parse_ques_set_ques_no: currentQuestion.ques_no,
//       parse_ques_set_ques_type: currentQuestion.ques_type,
//       question_text: currentQuestion.question_text, // Unedited question text
//       status: 2, // Mark as reviewed
//       initial_reviewed_by: userName,
//       initial_reviewed_on: new Date().toISOString(),
//       options: currentQuestion.options.map((option, index) => ({
//         parse_ques_set_option_id: option.option_id,
//         parse_ques_set_id: selectedSetId,
//         parse_ques_set_question_id: currentQuestion.question_id,
//         parse_ques_option_no: option.option_no || index + 1,
//         parse_ques_option_bool_type: option.option_bool_type,
//         option_text: option.option_text,
//         parse_ques_option_correct_flag: option.option_correct_flag,
//         parse_ques_option_weightage: option.option_weightage,
//       })),
//     };

//     nonData[currentQuestion.question_id] = questionData;
//     localStorage.setItem("NON", JSON.stringify(nonData));
//   } else {
//     // **EDIT MODE (Taking Correct Values from NewDataCOA)**
//     console.log("================================NewDataCOA", NewDataCOA);
//     NewDataCOA.OptionTextNewDataChild.forEach((option) => {
//       console.log(
//         `Option No: ${option.option_no}, Correct Flag: ${option.option_correct_flag}`
//       );
//     });

//     questionData = {
//       parse_ques_set_question_id: currentQuestion.question_id,
//       parse_ques_set_id: selectedSetId,
//       parse_ques_set_ques_no: currentQuestion.ques_no,
//       parse_ques_set_ques_type: currentQuestion.ques_type,
//       question_text: NewDataCOA.QuestionTextNewDataChild, // **Edited question text**
//       status: 2,
//       initial_reviewed_by: userName,
//       initial_reviewed_on: new Date().toISOString(),
//       options: NewDataCOA.OptionTextNewDataChild.map((option) => ({
//         parse_ques_set_option_id: option.option_id,
//         parse_ques_set_id: selectedSetId,
//         parse_ques_set_question_id: currentQuestion.question_id,
//         parse_ques_option_no: option.option_no, //  TAKEN DIRECTLY FROM NewDataCOA
//         parse_ques_option_bool_type: option.option_bool_type,
//         option_text: option.option_text,
//         parse_ques_option_correct_flag: option.option_correct_flag, //  TAKEN DIRECTLY FROM NewDataCOA
//         parse_ques_option_weightage: option.option_weightage,
//       })),
//     };

//     popData[currentQuestion.question_id] = questionData;
//     localStorage.setItem("POP", JSON.stringify(popData));
//   }

//   //  Update `TagsMain`
//   tagsMainData[currentQuestion.question_id] = updatedTags.map((tag) => ({
//     tag_id: tag.parse_ques_tag_id,
//     tag_value_id: tag.parse_ques_tag_value_id,
//     tag_name:
//       tags.find((t) => t.parse_tag_id === tag.parse_ques_tag_id)
//         ?.parse_tag_name || "Unknown",
//   }));
//   localStorage.setItem("TagsMain", JSON.stringify(tagsMainData));

//   //  Update `TagsPOP`
//   const filteredTagsData = tagsData.filter(
//     (tag) => tag.parse_ques_set_question_id !== currentQuestion.question_id
//   );
//   const newTagsFormatted = updatedTags.map((tag) => ({
//     parse_ques_set_id: selectedSetId,
//     parse_ques_set_question_id: currentQuestion.question_id,
//     parse_ques_tag_id: tag.parse_ques_tag_id,
//     parse_ques_tag_value_id: tag.parse_ques_tag_value_id,
//   }));

//   localStorage.setItem(
//     "TagsPOP",
//     JSON.stringify([...filteredTagsData, ...newTagsFormatted])
//   );

//   console.log(" Updated TagsPOP (New Structure):", newTagsFormatted);

//   //  Move to the next question
//   const nextIndex =
//     questionsData.findIndex(
//       (q) => q.question_id === currentQuestion.question_id
//     ) + 1;
//   if (nextIndex < questionsData.length) {
//     setCurrentQuestion(questionsData[nextIndex]); // 🎯 Triggers `useEffect` to fetch new tags
//   }

//   //  Reset UI states
//   setShowTwoInputs(false);
//   setIsEditMode(false);
// };

//   const applyTagsToAll = () => {
//     const existingTags = JSON.parse(localStorage.getItem("TagsPOP")) || {};
//     const tagsForAll = prepareTags(); // Prepare the current tagging values

//     // Apply the current tagging to all questions
//     questionsData.forEach((question) => {
//       existingTags[question.question_id] = tagsForAll.map((tag) => ({
//         ...tag,
//         parse_ques_set_id: selectedSetId, // Include selectedSetId
//       }));
//     });

//     localStorage.setItem("TagsPOP", JSON.stringify(existingTags));
//     // alert("Tags applied to all questions successfully!");
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div
//         className="Container-messageBOX"
//         onMouseEnter={pauseTimer}
//         onMouseLeave={resumeTimer}
//       >
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Tags applied to all questions successfully!</span>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);
//   };

//   const displayQuestionWithImages = (questionId) => {
//     try {
//       const questionData = JSON.parse(localStorage.getItem("POP"))?.[
//         questionId
//       ];
//       const imagesData = JSON.parse(localStorage.getItem("ImagesPOP"))?.[
//         questionId
//       ];

//       if (questionData && imagesData) {
//         let questionText = questionData.question_text;
//         imagesData.forEach((img) => {
//           const imgTag = `<img src="${img.base64}" class="Img-RQ-QnsAns" alt="${img.name}" />`;
//           questionText = questionText.replace(img.placeholder, imgTag);
//         });
//         return questionText;
//       }
//     } catch (error) {
//       console.error("Error merging question and images:", error);
//     }
//     return null;
//   };

//   const replaceImagesWithPlaceholders = (text, questionId) => {
//     const imgRegex =
//       /<img src="(data:image\/[^;]+;base64,[^"]+)"[^>]*alt="([^"]+)"[^>]*>/g; // Match all base64 images
//     const images = [];
//     let match;
//     let counter = 1; // Initialize a counter for sequential naming

//     // Replace base64 images with placeholders
//     const updatedText = text.replace(imgRegex, (match, src, alt) => {
//       const uniqueName = alt ? alt : `image_${counter}`; // Use alt attribute if available, else fallback to sequential naming
//       const placeholder = `#<${uniqueName}>#`; // Placeholder format

//       images.push({ name: uniqueName, base64: src, placeholder }); // Store mapping
//       counter++; // Increment counter for the next image
//       return placeholder; // Replace the <img> tag with the placeholder
//     });

//     // Save images with placeholders into localStorage
//     const existingImages = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
//     existingImages[questionId] = images; // Save images mapped to the current question ID
//     localStorage.setItem("ImagesPOP", JSON.stringify(existingImages));

//     return updatedText; // Return the text with placeholders
//   };

//   ////////////////////////////////////////////////////////////////////////
//   // Function to store question tags in localStorage
//   const storeTagsInLocalStorage = (questions) => {
//     if (!Array.isArray(questions) || questions.length === 0) {
//       console.warn("⚠️ No questions data provided.");
//       return;
//     }

//     // Initialize an empty object for storing tags per question_id
//     const tagsMain = {};

//     // Loop through each question and extract its tags
//     questions.forEach((question) => {
//       const { question_id, tags } = question;

//       if (Array.isArray(tags) && tags.length > 0) {
//         tagsMain[question_id] = tags.map((tag) => ({
//           tag_id: tag.tag_id,
//           tag_value_id: tag.tag_value_id,
//           tag_name: tag.tag_name,
//         }));
//       }
//     });

//     // Save to localStorage
//     localStorage.setItem("TagsMain", JSON.stringify(tagsMain));

//     console.log(" Tags stored successfully in localStorage:", tagsMain);
//   };

//   //  Run this function when the page loads
//   useEffect(() => {
//     storeTagsInLocalStorage(questionsData);
//   }, [questionsData]); // Runs every time questionsData is updated

//   const matchAndSetCourseDropdown = (
//     currentQuestionId,
//     coursesData,
//     setSelectedCourseLabel,
//     setValues
//   ) => {
//     // Retrieve stored tags from localStorage
//     const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

//     if (!tagsMain[currentQuestionId]) {
//       console.warn(`No tags found for question ID: ${currentQuestionId}`);
//       return;
//     }

//     // Find the Course tag
//     const courseTag = tagsMain[currentQuestionId].find(
//       (tag) => tag.tag_name === "Course"
//     );

//     if (!courseTag) {
//       console.warn("No Course tag found for this question.");
//       return;
//     }

//     // Match the tag_value_id with course_id in API response
//     const matchedCourse = coursesData.find(
//       (course) => course.course_id === courseTag.tag_value_id
//     );

//     if (matchedCourse) {
//       console.log("Matched Course:", matchedCourse);
//       setSelectedCourseLabel(matchedCourse.course_description); // Set selected dropdown label
//       setValues((prevValues) => ({
//         ...prevValues,
//         course_id: matchedCourse.course_id,
//       })); // Update state
//     } else {
//       console.warn(
//         "No matching course found for tag_value_id:",
//         courseTag.tag_value_id
//       );
//     }
//   };

//   useEffect(() => {
//     if (currentQuestion && coursesdata.length > 0) {
//       matchAndSetCourseDropdown(
//         currentQuestion.question_id,
//         coursesdata,
//         setSelectedCourseLabel,
//         setValues
//       );
//     }
//     // }, [currentQuestion]);
//   }, [currentQuestion, coursesdata]);

//   const matchAndSetSubjectDropdown = (
//     currentQuestionId,
//     subjectsData,
//     setSelectedSubjectLabel,
//     setSelectedSubject
//   ) => {
//     // Retrieve stored tags from localStorage
//     const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

//     if (!tagsMain[currentQuestionId]) {
//       console.warn(`No tags found for question ID: ${currentQuestionId}`);
//       return;
//     }

//     // Find the "Subject" tag
//     const subjectTag = tagsMain[currentQuestionId].find(
//       (tag) => tag.tag_name === "Subject"
//     );

//     if (!subjectTag) {
//       console.warn("No Subject tag found for this question.");
//       return;
//     }

//     // Match the tag_value_id with subject_id in API response
//     const matchedSubject = subjectsData.find(
//       (subject) => subject.subject_id === subjectTag.tag_value_id
//     );

//     if (matchedSubject) {
//       console.log("Matched Subject:", matchedSubject);
//       setSelectedSubjectLabel(matchedSubject.subject_name); // Set selected dropdown label
//       setSelectedSubject(matchedSubject.subject_id); // Update state
//     } else {
//       console.warn(
//         "No matching subject found for tag_value_id:",
//         subjectTag.tag_value_id
//       );
//     }
//   };

//   useEffect(() => {
//     if (currentQuestion && subjects.length > 0) {
//       matchAndSetSubjectDropdown(
//         currentQuestion.question_id,
//         subjects,
//         setSelectedSubjectLabel,
//         setSelectedSubject
//       );
//     }
//     // }, [currentQuestion]);
//   }, [currentQuestion, subjects]);

//   const matchAndSetChapterDropdown = (
//     currentQuestionId,
//     chaptersData,
//     setSelectedChapterLabel,
//     setSelectedChapter
//   ) => {
//     // Retrieve stored tags from localStorage
//     const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

//     if (!tagsMain[currentQuestionId]) {
//       console.warn(`No tags found for question ID: ${currentQuestionId}`);
//       return;
//     }

//     // Find the Chapter tag
//     const chapterTag = tagsMain[currentQuestionId].find(
//       (tag) => tag.tag_name === "Chapter"
//     );

//     if (!chapterTag) {
//       console.warn("No Chapter tag found for this question.");
//       return;
//     }

//     // Match the tag_value_id with chapter_id in API response
//     const matchedChapter = chaptersData.find(
//       (chapter) => chapter.chapter_id === chapterTag.tag_value_id
//     );

//     if (matchedChapter) {
//       console.log("Matched Chapter:", matchedChapter);
//       setSelectedChapterLabel(matchedChapter.chapter_desc); // Set selected dropdown label
//       setSelectedChapter(matchedChapter.chapter_id); // Update selected chapter ID
//     } else {
//       console.warn(
//         "No matching chapter found for tag_value_id:",
//         chapterTag.tag_value_id
//       );
//     }
//   };

//   useEffect(() => {
//     if (currentQuestion && chapters.length > 0) {
//       matchAndSetChapterDropdown(
//         currentQuestion.question_id,
//         chapters,
//         setSelectedChapterLabel,
//         setSelectedChapter
//       );
//     }
//     // }, [currentQuestion]);
//   }, [currentQuestion, chapters]); // Depend on currentQuestion and fetched chapters data

//   const matchAndSetTopicDropdown = (
//     currentQuestionId,
//     topicsData,
//     setSelectedTopicLabel,
//     setTopicId
//   ) => {
//     // Retrieve stored tags from localStorage
//     const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

//     if (!tagsMain[currentQuestionId]) {
//       console.warn(`No tags found for question ID: ${currentQuestionId}`);
//       return;
//     }

//     // Find the Topic tag
//     const topicTag = tagsMain[currentQuestionId].find(
//       (tag) => tag.tag_name === "Topic"
//     );

//     if (!topicTag) {
//       console.warn("No Topic tag found for this question.");
//       return;
//     }

//     // Match the tag_value_id with topic_id in API response
//     const matchedTopic = topicsData.find(
//       (topic) => topic.topic_id === topicTag.tag_value_id
//     );

//     if (matchedTopic) {
//       console.log("Matched Topic:", matchedTopic);
//       setSelectedTopicLabel(matchedTopic.topic_name); // Set selected dropdown label
//       setTopicId(matchedTopic.topic_id); // Update selected topic ID
//     } else {
//       console.warn(
//         "No matching topic found for tag_value_id:",
//         topicTag.tag_value_id
//       );
//     }
//   };

//   useEffect(() => {
//     if (currentQuestion) {
//       const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};

//       if (tagsMainData[currentQuestion.question_id]) {
//         const currentTags = tagsMainData[currentQuestion.question_id];

//         const topicTag = currentTags.find((tag) => tag.tag_id === 5);
//         if (topicTag) {
//           console.log("🟢 Loading Topic from TagsMain:", topicTag.tag_value_id);
//           setTopicId(topicTag.tag_value_id);
//           setSelectedTopicLabel(
//             topics.find((top) => top.topic_id === topicTag.tag_value_id)
//               ?.topic_name || "Select Topic"
//           );
//         } else {
//           console.warn("⚠️ No matching topic found in TagsMain");
//         }
//       }
//     }
//   }, [currentQuestion, topics]);

//   useEffect(() => {
//     if (currentQuestion && topics.length > 0) {
//       matchAndSetTopicDropdown(
//         currentQuestion.question_id,
//         topics,
//         setSelectedTopicLabel,
//         setTopicId
//       );
//     }
//     // }, [currentQuestion]); // Depend on currentQuestion and fetched topics data
//   }, [currentQuestion, topics]); // Depend on currentQuestion and fetched topics data

//   const matchAndSetDropdownTags = (
//     currentQuestionId,
//     tags, // API response
//     setSelectedDifficultyLevelLabel,
//     setSelectedPYQLabel,
//     setSelectedTestTagLabel,
//     setSelectedImportantLabel,
//     setDropdownData
//   ) => {
//     // Retrieve stored tags from localStorage
//     const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

//     if (!tagsMain[currentQuestionId]) {
//       console.warn(`No tags found for question ID: ${currentQuestionId}`);
//       return;
//     }

//     // Tag IDs for each category
//     const tagMapping = {
//       8: {
//         setLabel: setSelectedDifficultyLevelLabel,
//         label: "Difficulty Level",
//       },
//       9: { setLabel: setSelectedPYQLabel, label: "PYQ" },
//       1: { setLabel: setSelectedTestTagLabel, label: "Test Tag" },
//       6: { setLabel: setSelectedImportantLabel, label: "Important" },
//     };

//     Object.entries(tagMapping).forEach(([tagId, { setLabel, label }]) => {
//       // Find the tag in local storage for this question
//       const storedTag = tagsMain[currentQuestionId].find(
//         (tag) => tag.tag_id == tagId
//       );

//       if (!storedTag) {
//         console.warn(`No ${label} tag found for this question.`);
//         return;
//       }

//       // Match the tag_value_id with API response
//       const matchedTag = tags
//         .find((tag) => tag.parse_tag_id == tagId)
//         ?.parse_tag_value.find(
//           (value) => value.parse_tag_value_id == storedTag.tag_value_id
//         );

//       if (matchedTag) {
//         console.log(`Matched ${label}:`, matchedTag);
//         setLabel(matchedTag.tag_value); // Set selected dropdown label
//         setDropdownData((prevData) => ({
//           ...prevData,
//           [tagId]: matchedTag.parse_tag_value_id, // Update state
//         }));
//       } else {
//         console.warn(
//           `No matching ${label} found for tag_value_id:`,
//           storedTag.tag_value_id
//         );
//       }
//     });
//   };

//   useEffect(() => {
//     if (currentQuestion && tags.length > 0) {
//       matchAndSetDropdownTags(
//         currentQuestion.question_id,
//         tags,
//         setSelectedDifficultyLevelLabel,
//         setSelectedPYQLabel, //  Pass PYQ state
//         setSelectedTestTagLabel, //  Pass Test Tag state
//         setSelectedImportantLabel, //  Pass Important state
//         setDropdownData
//       );
//     }
//   }, [currentQuestion, tags]); // Depend on currentQuestion and fetched tags data

//   useEffect(() => {
//     if (currentQuestion) {
//       const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};

//       if (tagsMainData[currentQuestion.question_id]) {
//         const currentTags = tagsMainData[currentQuestion.question_id];

//         //  Dynamically match `parse_tag_id` (API) with `tag_id` (LocalStorage)
//         const updatedDropdownData = {};
//         const updatedCheckedTags = {};

//         currentTags.forEach((tag) => {
//           const matchingTag = tags.find((t) => t.parse_tag_id === tag.tag_id);
//           if (matchingTag) {
//             if (matchingTag.parse_tag_type === 1) {
//               updatedDropdownData[tag.tag_id] = tag.tag_value_id;
//             } else if (matchingTag.parse_tag_type === 2) {
//               updatedCheckedTags[tag.tag_id] = tag.tag_value_id === 1;
//             }
//           }
//         });

//         //  Update State for Dropdowns
//         setDropdownData((prev) => ({
//           ...prev,
//           ...updatedDropdownData,
//         }));

//         //  Update State for Checkboxes
//         setCheckedTags(updatedCheckedTags);

//         //  Update Course Dropdown
//         const courseTag = currentTags.find((tag) => tag.tag_id === 2);
//         if (courseTag) {
//           setValues({ course_id: courseTag.tag_value_id });
//           setSelectedCourseLabel(
//             coursesdata.find(
//               (course) => course.course_id === courseTag.tag_value_id
//             )?.course_description || "Select Course"
//           );
//         }

//         //  Update Subject Dropdown
//         const subjectTag = currentTags.find((tag) => tag.tag_id === 3);
//         if (subjectTag) {
//           setSelectedSubject(subjectTag.tag_value_id);
//           setSelectedSubjectLabel(
//             subjects.find((sub) => sub.subject_id === subjectTag.tag_value_id)
//               ?.subject_name || "Select Subject"
//           );
//         }

//         //  Update Chapter Dropdown (Existing Logic)
//         const chapterTag = currentTags.find((tag) => tag.tag_id === 4);
//         if (chapterTag) {
//           setSelectedChapter(chapterTag.tag_value_id);
//           setSelectedChapterLabel(
//             chapters.find((chap) => chap.chapter_id === chapterTag.tag_value_id)
//               ?.chapter_name || "Select Chapter"
//           );
//         }

//         //  Update Topic Dropdown (Now EXACTLY like Chapter Dropdown)
//         const topicTag = currentTags.find((tag) => tag.tag_id === 5);
//         if (topicTag) {
//           setTopicId(topicTag.tag_value_id);
//           setSelectedTopicLabel(
//             topics.find((top) => top.topic_id === topicTag.tag_value_id)
//               ?.topic_name || "Select Topic"
//           );
//         }
//       }
//     }
//   }, [currentQuestion]);

//   return (
//     <>
//       <div className="Header-up">
//         <span className="span-RQ">
//           Review Question{" "}
//           <span style={{ color: "lightgrey" }}>{/* / {setNameSet} */}</span>
//         </span>
//         <div style={{ marginRight: "30px" }}>
//           {errorCount > 1 && ( // Show the button only if error count exceeds 1
//             <button
//               className="testreportcard-cancel-btn width-superseeding-2"
//               onClick={clearLocalStorage}
//               style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             >
//               Clear Faulty Data
//             </button>
//           )}

//           <button
//             className="testreportcard-cancel-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => navigate(-1)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-cancel-btn"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={() => handleUpdateQuestion(false)} // false for SAVE
//           >
//             SAVE
//           </button>
//           <button
//             className="testreportcard-create-btn width-superseeding-2"
//             style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
//             onClick={handleSubmitSelectedReview} // Directly reference the function
//           >
//             Submit selected review
//           </button>
//         </div>
//       </div>
//       <div style={{ paddingLeft: "30px", paddingTop: "15px" }}>
//         <div className="container-RQ-first-90">
//           <div className="three-lines-css-RQ">
//             <div style={{ color: "#424342" }}>QUESTION TAGGING</div>{" "}
//             <div>
//               <img
//                 src={minusImgClose}
//                 alt=""
//                 style={{ cursor: "pointer" }}
//                 onClick={toggleSectionVisibility} // Toggle visibility on click
//               />
//             </div>
//           </div>
//         </div>

//         <div
//           style={{
//             display: isSectionVisible ? "block" : "none", // Conditional display based on state
//           }}
//           className="container-RQ-first-90-2"
//         >
//           {isOpenTagging && (
//             <div className="">
//               <div className="grid-container-tagging">
//                 <div className="grid-item">
//                   <AddOptionDropdwon
//                     label="Set Name"
//                     placeholder={setNameSet} // Correct way to pass the variable dynamically
//                     setSelected={(selectedOption) => {
//                       if (selectedOption) {
//                         setSelectedSetName(selectedOption);
//                         setSelectedSetId(selectedOption.id); // Update state with the selected ID
//                       }
//                     }}
//                     options={setNames}
//                     setOptions={setSetNames}
//                     isRequired={true}
//                     Height="auto"
//                     OverFlow="auto"
//                     minheight="300px"
//                     disabled={true}
//                   />
//                 </div>
//                 <div className="grid-item">
//                   <DropDown
//                     placeholder={selectedCourseLabel || "Select Course"} // Ensure it's actually used
//                     label="Course"
//                     setSelected={(selectedOption) => {
//                       if (selectedOption) {
//                         const selectedCourseObj = coursesdata.find(
//                           (course) => course.course_id === selectedOption
//                         );

//                         setValues((prevValues) => ({
//                           ...prevValues,
//                           course_id: selectedOption, //  Update course_id state
//                         }));

//                         setSelectedCourseLabel(
//                           selectedCourseObj?.course_description ||
//                             "Select Course"
//                         ); //  Update selectedCourseLabel
//                       } else {
//                         // If selection is cleared, retain previous course
//                         const initialCourse = coursesdata.find(
//                           (course) =>
//                             course.course_id ===
//                             currentQuestion.course_tag_value_id
//                         );

//                         setValues({
//                           course_id: currentQuestion.course_tag_value_id,
//                         });

//                         setSelectedCourseLabel(
//                           initialCourse?.course_description || "Select Course"
//                         ); //  Ensure selectedCourseLabel updates
//                       }
//                     }}
//                     selectedLabel={selectedCourseLabel}
//                     options={
//                       coursesdata
//                         ? coursesdata.map((course) => ({
//                             label: course.course_description,
//                             id: course.course_id,
//                           }))
//                         : []
//                     }
//                     isRequired={true}
//                   />
//                 </div>
//                 <div className="grid-item">
//                   <DropDownUP
//                     label="Subject"
//                     placeholder={selectedSubjectLabel || "Select Subject"} // Show initial value or default placeholder
//                     setSelected={(selectedOption) => {
//                       if (selectedOption) {
//                         setSelectedSubject(selectedOption); // Update the selected subject ID

//                         console.log(
//                           "New Selected Subject Label:",
//                           selectedOption.label
//                         );
//                         setSelectedSubjectLabel(selectedOption.label); // Update the selected subject label
//                       }
//                     }}
//                     selectedLabel={selectedSubjectLabel} // Pass the selected label for display
//                     setSelectedLabel={setSelectedSubjectLabel} // Allow dynamic label update
//                     options={subjects.map((subject) => ({
//                       label: subject.subject_name,
//                       id: subject.subject_id,
//                     }))} // Subject options
//                     isRequired={true}
//                   />
//                 </div>
//                 <div className="grid-item">
//                   <DropDownUP
//                     label="Chapter"
//                     placeholder={selectedChapterLabel || "Select Chapter"} // Show pre-selected value or default
//                     setSelected={(selectedOption) => {
//                       if (selectedOption) {
//                         setSelectedChapter(selectedOption); // Update the
//                       } else {
//                         // If the user clears the selection, reset to defaults
//                         setSelectedChapter(
//                           currentQuestion.chapter_tag_value_id
//                         );
//                         setSelectedChapterLabel("Select Chapter");
//                       }
//                     }}
//                     selectedLabel={selectedChapterLabel} // Dynamically display the selected label
//                     setSelectedLabel={setSelectedChapterLabel} // Allow updates to the displayed label
//                     options={chapters.map((chapter) => ({
//                       label: chapter.chapter_name,
//                       id: chapter.chapter_id,
//                     }))}
//                   />
//                 </div>
//                 <div className="grid-item">
//                   <DropDownUP2
//                     label="Topic"
//                     placeholder={selectedTopicLabel || "Select Topic"}
//                     setSelected={(selectedOption) => {
//                       if (selectedOption) {
//                         setSelectedTopic(selectedOption);
//                       } else {
//                         // If the user clears the selection, reset to defaults
//                         setSelectedTopic(currentQuestion.topic_tag_value_id);
//                         setSelectedChapterLabel("Select Chapter");
//                       }
//                     }}
//                     selectedLabel={selectedTopicLabel}
//                     setSelectedLabel={setSelectedTopicLabel}
//                     options={topics.map((topic) => ({
//                       label: topic.topic_name,
//                       id: topic.topic_id,
//                     }))}
//                   />
//                 </div>
//                 {/* Dropdowns */}

//                 {tags
//                   .filter((tag) => tag.parse_tag_type === 1) // Only dropdown-type tags
//                   .map((tag) => {
//                     // Get the currently selected value from state
//                     const selectedValue = dropdownData[tag.parse_tag_id] || "";

//                     // Find the corresponding label (if selected)
//                     const matchedOption = tag.parse_tag_value.find(
//                       (value) => value.parse_tag_value_id === selectedValue
//                     );
//                     const selectedLabel = matchedOption
//                       ? matchedOption.tag_value
//                       : `Select ${tag.parse_tag_name}`;

//                     return (
//                       <div className="grid-item" key={tag.parse_tag_id}>
//                         <DropDownMN
//                           label={tag.parse_tag_name} // Dynamic label
//                           selected={selectedValue} //  Ensure selected value is passed correctly
//                           setSelected={(selectedOptionId) => {
//                             setDropdownData((prevData) => ({
//                               ...prevData,
//                               [tag.parse_tag_id]: selectedOptionId, //  Store only ID, not the whole object
//                             }));

//                             //  Dynamically update label state for specific dropdowns if needed
//                             if (tag.tag_id === 8) {
//                               setSelectedDifficultyLevelLabel(
//                                 tag.parse_tag_value.find(
//                                   (value) =>
//                                     value.parse_tag_value_id ===
//                                     selectedOptionId
//                                 )?.tag_value || "Select Difficulty Level"
//                               );
//                             }
//                           }}
//                           options={tag.parse_tag_value.map((value) => ({
//                             label: value.tag_value,
//                             id: value.parse_tag_value_id,
//                           }))} // Dynamic options
//                           placeholder={selectedLabel} //  Dynamically update placeholder for each dropdown
//                         />
//                       </div>
//                     );
//                   })}
//               </div>
//               <div className="row-cs-uni">
//                 <div className="row-cs-uni">
//                   {tags
//                     .filter(
//                       (tag) =>
//                         tag.parse_tag_type === 2 && // Ensure the tag has the correct parse_tag_type
//                         tag.parse_tag_id && // Ensure tag has a valid parse_tag_id
//                         tag.parse_tag_name // Ensure tag has a valid parse_tag_name
//                     )
//                     .map((tag) => (
//                       <div
//                         style={{ marginLeft: "10px" }}
//                         key={tag.parse_tag_id}
//                       >
//                         <div>
//                           <input
//                             style={{ marginRight: "6px" }}
//                             className="delete-question-checkbox-dqc"
//                             type="checkbox"
//                             id={`checkbox-${tag.parse_tag_id}`}
//                             checked={!!checkedTags[tag.parse_tag_id]} // Dynamically bind checked state
//                             onChange={(e) => {
//                               setCheckedTags((prevState) => ({
//                                 ...prevState,
//                                 [tag.parse_tag_id]: e.target.checked, // Update the tag's checked status
//                               }));
//                             }}
//                           />
//                           <label
//                             style={{ marginRight: "40px" }}
//                             htmlFor={`checkbox-${tag.parse_tag_id}`}
//                           >
//                             {tag.parse_tag_name}
//                           </label>
//                         </div>
//                       </div>
//                     ))}
//                 </div>
//               </div>
//               <div className="button-container">
//                 <button
//                   className="simple-review-parser-btn"
//                   onClick={applyTagsToAll}
//                 >
//                   Apply to All
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>

//         <div style={{ paddingTop: "15px", color: "#424342" }}>
//           <div className="container-RQ-first-90-3">
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 marginBottom: "5px",
//                 marginRight: "5px",
//               }}
//             >
//               {/* Left Side: Text and Image */}
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 {currentQuestion && (
//                   <p style={{ color: "#424342", marginRight: "10px" }}>
//                     QUESTION # {currentQuestion.ques_no}
//                   </p>
//                 )}
//                 <img
//                   onClick={handleImageClick}
//                   src={isEditMode ? UndoBack : pencil}
//                   style={{
//                     width: "20px",
//                     height: "20px",
//                     cursor: "pointer",
//                     marginLeft: "10px",
//                   }}
//                   alt={isEditMode ? "Undo Changes" : "Edit Question"}
//                 />
//               </div>

//               {/* Right Side: Minus Image */}
//               <div>
//                 <img src={minusImgClose} alt="Close" />
//               </div>
//             </div>
//           </div>
//           {showTwoInputs ? (
//             <div className="four-lines-css-RQ">
//               {" "}
//               <ReviewComponent
//                 questionText={currentQuestion?.question_text}
//                 optionFromAnotherPage={currentQuestion?.options}
//                 quesType={currentQuestion?.ques_type}
//                 quesNo={currentQuestion?.ques_no}
//                 setCurrentQuestion={setCurrentQuestion}
//                 fetchNewUpdatedDataValues={fetchNewUpdatedDataValues}
//                 handleReviewAndProceed={handleReviewAndProceed}
//                 globalImageCounter={globalImageCounter}
//                 setGlobalImageCounter={setGlobalImageCounter}
//               />
//             </div>
//           ) : (
//             <div className="container-RQ-first-90-4">
//               <div>
//                 {currentQuestion &&
//                   (() => {
//                     // Retrieve local storage data
//                     const popData =
//                       JSON.parse(localStorage.getItem("POP")) || {};
//                     const storedQuestion = popData[currentQuestion.question_id];

//                     // Use local storage question if available; otherwise, use API-fetched data
//                     const displayedQuestion = storedQuestion
//                       ? storedQuestion
//                       : currentQuestion;

//                     return (
//                       <div>
//                         <div>
//                           <h3
//                             className="Qns-RQ-Question"
//                             style={{ marginBottom: "1px" }}
//                           >
//                             Question:
//                           </h3>
//                           <p
//                             className="Qns-RQ-Question-2"
//                             dangerouslySetInnerHTML={{
//                               __html: processText(
//                                 displayedQuestion.question_text
//                               ),
//                             }}
//                           ></p>
//                         </div>
//                         <ul>
//                           {displayedQuestion.options?.map((option, index) => {
//                             const isChecked =
//                               option.parse_ques_option_correct_flag !==
//                               undefined
//                                 ? option.parse_ques_option_correct_flag === 1
//                                 : option.option_correct_flag === 1; // Fallback for API-fetched questions

//                             return (
//                               <li key={index} className="Qns-RQ-Options">
//                                 <input
//                                   type="radio"
//                                   name={`option-${displayedQuestion.question_id}-${index}`} //  Unique per option
//                                   checked={isChecked}
//                                   disabled //  Prevents user interaction
//                                   style={{
//                                     marginRight: "10px",
//                                     cursor: "not-allowed",
//                                     accentColor: isChecked ? "#4CAF50" : "#ccc",
//                                   }}
//                                 />
//                                 <span
//                                   className="Qns-RQ-Options-2"
//                                   dangerouslySetInnerHTML={{
//                                     __html: processText(option.option_text),
//                                   }}
//                                 ></span>
//                               </li>
//                             );
//                           })}
//                         </ul>
//                       </div>
//                     );
//                   })()}
//               </div>
//             </div>
//           )}
//         </div>

//         <div style={{ width: "81vw", padding: "5px" }}>
//           <div style={{ width: "81vw", padding: "5px" }}>
//             <div className="row-space-between">
//               <div className="flex-gap">
//                 <div>
//                   <button className="grey-submitted-parser width-overwrite"></button>
//                   <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
//                     Submitted
//                   </label>
//                 </div>
//                 <div>
//                   <button className="blue-review-parser width-overwrite"></button>
//                   <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
//                     Reviewed
//                   </label>
//                 </div>
//                 <div>
//                   <button className="White-Not-review-parser width-overwrite"></button>
//                   <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
//                     Not Reviewed
//                   </label>
//                 </div>
//               </div>

//               <div className="flex-gap">
//                 <button
//                   onClick={handlePreviousButtonClick}
//                   className="simple-review-parser-btn"
//                   aria-label="Previous"
//                 >
//                   Previous
//                 </button>
//                 <button
//                   className="simple-review-parser-btn"
//                   onClick={handleDeleteQuestion}
//                   disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
//                   style={{
//                     cursor:
//                       currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
//                   }}
//                   aria-label="Delete / Restore"
//                 >
//                   {currentQuestion &&
//                   deletedQuestions.includes(currentQuestion.question_id)
//                     ? "Restore"
//                     : "Delete"}
//                 </button>

//                 <button
//                   onClick={handleSkipReview}
//                   className="simple-review-parser-btn"
//                   disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
//                   style={{
//                     cursor:
//                       currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
//                   }}
//                   aria-label="Skip Review"
//                 >
//                   Skip Review
//                 </button>

//                 <button
//                   onClick={handleReviewAndProceed}
//                   className="simple-review-parser-btn"
//                   disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
//                   style={{
//                     cursor:
//                       currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
//                   }}
//                   aria-label="Review and Proceed"
//                 >
//                   Review & Proceed
//                 </button>
//               </div>
//             </div>

//             <div className="flex-gap width-superseeding Selection-Button-RQ">
//               <div className="Selection-Button-RQ">
//                 {questionsData.map((question) => (
//                   <button
//                     style={{
//                       margin: "3px",
//                       opacity: isEditMode ? 0.5 : 1, // Reduce opacity when disabled
//                       cursor: isEditMode ? "not-allowed" : "pointer", // Show 'not-allowed' cursor
//                     }}
//                     className={getButtonClass(question)}
//                     key={question.question_id}
//                     onClick={() => {
//                       if (!isEditMode) {
//                         handleButtonClick(question); // Only call if not in edit mode
//                       }
//                     }}
//                     disabled={isEditMode} // Disable button when in edit mode
//                   >
//                     {question.ques_no}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ReviewQuestion;
// // 19709
// // 19716

// import { useEffect } from "react";
// import React from "react";

// const CompareTags = () => {
//   // First data (from TagsPOP – normalized keys)
//   useEffect(() => {
//     // Disable right-click context menu
//     const handleContextMenu = (event) => {
//       event.preventDefault();
//     };

//     // Disable common keyboard shortcuts
//     const handleKeyDown = (event) => {
//       if (
//         event.keyCode === 123 || // F12
//         (event.ctrlKey && event.shiftKey && event.keyCode === 73) || // Ctrl+Shift+I
//         (event.ctrlKey && event.shiftKey && event.keyCode === 74) || // Ctrl+Shift+J
//         (event.ctrlKey && event.keyCode === 85) // Ctrl+U
//       ) {
//         event.preventDefault();
//       }
//     };

//     document.addEventListener('contextmenu', handleContextMenu);
//     document.addEventListener('keydown', handleKeyDown);

//     // Cleanup event listeners on component unmount
//     return () => {
//       document.removeEventListener('contextmenu', handleContextMenu);
//       document.removeEventListener('keydown', handleKeyDown);
//     };
//   }, []);

//   const data1 = [
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 8,
//       parse_ques_tag_value_id: 3,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 13,
//       parse_ques_tag_value_id: 17,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 9,
//       parse_ques_tag_value_id: 19,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 20,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 11,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 17,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 12,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 18,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 15,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 19,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 6,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 16,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 1,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 14,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 7,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 2,
//       parse_ques_tag_value_id: 2,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 3,
//       parse_ques_tag_value_id: 6,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 4,
//       parse_ques_tag_value_id: 122,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21027,
//       parse_ques_tag_id: 5,
//       parse_ques_tag_value_id: 768,
//     },
//   ];

//   // Second data (Master list of tags)
//   const data2 = [
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 8,
//       parse_ques_tag_value_id: 3,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 13,
//       parse_ques_tag_value_id: 17,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 9,
//       parse_ques_tag_value_id: 19,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 20,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 11,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 17,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 12,
//       parse_ques_tag_value_id: 1,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 18,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 15,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 19,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 6,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 16,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 1,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 14,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 7,
//       parse_ques_tag_value_id: 0,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 2,
//       parse_ques_tag_value_id: 2,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 3,
//       parse_ques_tag_value_id: 5,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 4,
//       parse_ques_tag_value_id: 69,
//     },
//     {
//       parse_ques_set_id: "2158",
//       parse_ques_set_question_id: 21028,
//       parse_ques_tag_id: 5,
//       parse_ques_tag_value_id: 474,
//     },
//   ];

//   // Normalize data1:
//   // Replace a value of 0 with null and map keys for consistency.
//   const normalizedData1 = data1.map((item) => ({
//     parse_ques_set_id: item.parse_ques_set_id,
//     parse_ques_set_question_id: item.parse_ques_set_question_id,
//     tag_id: item.parse_ques_tag_id,
//     tag_value_id:
//       item.parse_ques_tag_value_id === 0 ? null : item.parse_ques_tag_value_id,
//   }));

//   // Build dictionaries keyed by tag_id for both datasets.
//   const dict1 = {};
//   normalizedData1.forEach((item) => {
//     dict1[item.tag_id] = item;
//   });

//   const dict2 = {};
//   data2.forEach((item) => {
//     dict2[item.tag_id] = item;
//   });

//   // Create a union of all tag_ids from both datasets.
//   const allTagIds = Array.from(
//     new Set([...Object.keys(dict1), ...Object.keys(dict2)])
//   );

//   // Compare the tag_value_id from both data sources.
//   const differences = allTagIds
//     .map((tagId) => {
//       const d1 = dict1[tagId] || {};
//       const d2 = dict2[tagId] || {};
//       // For clarity, d1.tag_value_id may be undefined if not found.
//       const value1 = d1.tag_value_id === undefined ? null : d1.tag_value_id;
//       const value2 = d2.tag_value_id === undefined ? null : d2.tag_value_id;
//       const isDifferent = value1 !== value2;
//       return {
//         tag_id: tagId,
//         tag_name: d2.tag_name || d1.tag_name || "",
//         tag_value_id_data1: value1,
//         tag_value_id_data2: value2,
//         isDifferent,
//       };
//     })
//     .filter((item) => item.isDifferent);

//   return (
//     <div>
//       <h2>Tag Differences</h2>
//       {differences.length === 0 ? (
//         <p>No differences found.</p>
//       ) : (
//         <table border="1" cellPadding="5">
//           <thead>
//             <tr>
//               <th>Tag ID</th>
//               <th>Tag Name</th>
//               <th>Data1 Value</th>
//               <th>Data2 Value</th>
//             </tr>
//           </thead>
//           <tbody>
//             {differences.map((diff) => (
//               <tr key={diff.tag_id}>
//                 <td>{diff.tag_id}</td>
//                 <td>{diff.tag_name}</td>
//                 <td>
//                   {diff.tag_value_id_data1 === null
//                     ? "null"
//                     : diff.tag_value_id_data1}
//                 </td>
//                 <td>
//                   {diff.tag_value_id_data2 === null
//                     ? "null"
//                     : diff.tag_value_id_data2}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default CompareTags;

// import React, { useState } from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const Pop3 = () => {
//   const [editorHtml, setEditorHtml] = useState("");

//   const handleChange = (html) => {
//     setEditorHtml(html);
//   };

//   const handleSubmit = () => {
//     console.log("Submitted HTML:", editorHtml);
//     alert("Submitted HTML:\n" + editorHtml);
//   };

//   // Flattened toolbar configuration with list and indent options included
//   const modules = {
//     toolbar: [
//       ["bold", "italic", "underline"],
//       [{ color: [] }],
//       [{ list: "ordered" }, { list: "bullet" }],
//       [{ indent: "-1" }, { indent: "+1" }]
//     ]
//   };

//   // Ensure that "indent" is added to the formats array.
//   const formats = [
//     "bold",
//     "italic",
//     "underline",
//     "color",
//     "list",
//     "bullet",
//     "indent"
//   ];

//   return (
//     <div>
//       <ReactQuill
//         value={editorHtml}
//         onChange={handleChange}
//         modules={modules}
//         formats={formats}
//         placeholder="Write something..."
//       />
//       <button onClick={handleSubmit}>Submit</button>
//       <h3>HTML Output Preview:</h3>
//       <pre style={{ backgroundColor: "#f5f5f5", padding: "10px" }}>
//         {editorHtml}
//       </pre>
//     </div>
//   );
// };

// export default Pop3;

////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useRef, useEffect, useState } from "react";
// import SpaceShipPlayer from "../../Assets/Images/CommanImages/spaceS.png";
// // Game constants
// const GAME_WIDTH = 480;
// const GAME_HEIGHT = 600;
// const PLAYER_WIDTH = 50;
// const PLAYER_HEIGHT = 50;
// const ENEMY_WIDTH = 32;
// const ENEMY_HEIGHT = 20;
// const BULLET_WIDTH = 4;
// const BULLET_HEIGHT = 12;
// const ENEMY_ROWS = 3;
// const ENEMY_COLS = 7;
// const ENEMY_GAP = 20;
// const ENEMY_START_Y = 60;
// const ENEMY_MOVE_INTERVAL = 30; // ms
// const ENEMY_STEP = 10;
// const PLAYER_SPEED = 8;
// const BULLET_SPEED = 10;
// const ENEMY_BULLET_SPEED = 5;

// function rectsCollide(a, b) {
//   return (
//     a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y
//   );
// }

// const GalaxiaGame = () => {
//   const [level, setLevel] = useState(1);

//   const divingEnemies = useRef([]);
//   const lastDiveTime = useRef(0);

//   const [score, setScore] = useState(0);
//   const [gameOver, setGameOver] = useState(false);
//   const [restartKey, setRestartKey] = useState(0); // for restarting
//   const requestRef = useRef();
//   const keys = useRef({});
//   const [_, setRerender] = useState(0); // force rerender

//   // Game state refs
//   const player = useRef({
//     x: GAME_WIDTH / 2 - PLAYER_WIDTH / 2,
//     y: GAME_HEIGHT - 60,
//     w: PLAYER_WIDTH,
//     h: PLAYER_HEIGHT,
//   });
//   const playerBullets = useRef([]);
//   const enemyBullets = useRef([]);
//   const enemies = useRef([]);
//   const enemyDir = useRef(1); // 1: right, -1: left
//   const enemyMoveTick = useRef(0);
//   const lives = useRef(3);

//   // Initialize enemies
//   const generateEnemies = (level) => {
//     const formations = [
//       { rows: 3, cols: 7, shape: "grid" },
//       { rows: 5, cols: 5, shape: "zigzag" },
//       { rows: 4, cols: 6, shape: "wave" },
//     ];
//     const { rows, cols, shape } = formations[(level - 1) % formations.length];

//     let arr = [];
//     for (let row = 0; row < rows; row++) {
//       for (let col = 0; col < cols; col++) {
//         let x = 40 + col * (ENEMY_WIDTH + ENEMY_GAP);
//         let y = ENEMY_START_Y + row * (ENEMY_HEIGHT + ENEMY_GAP);

//         // Apply formation patterns
//         if (shape === "zigzag") {
//           x += row % 2 === 0 ? 0 : ENEMY_WIDTH / 2;
//         } else if (shape === "wave") {
//           y += Math.sin(col + level) * 10;
//         }

//         arr.push({ x, y, w: ENEMY_WIDTH, h: ENEMY_HEIGHT, alive: true });
//       }
//     }
//     return arr;
//   };

//   // Handle keyboard
//   useEffect(() => {
//     const handleDown = (e) => {
//       keys.current[e.code] = true;
//       // Prevent scrolling with arrow keys
//       if (["ArrowLeft", "ArrowRight", "Space"].includes(e.code))
//         e.preventDefault();
//     };
//     const handleUp = (e) => {
//       keys.current[e.code] = false;
//     };
//     window.addEventListener("keydown", handleDown);
//     window.addEventListener("keyup", handleUp);
//     return () => {
//       window.removeEventListener("keydown", handleDown);
//       window.removeEventListener("keyup", handleUp);
//     };
//   }, []);

//   // Main game loop
//   useEffect(() => {
//     enemies.current = generateEnemies(level);

//     // setRestartKey((k) => k + 1); // force rerender

//     let lastShot = 0;
//     let lastEnemyShot = 0;

//     function gameLoop() {
//       if (gameOver) return;

//       // Player movement
//       if (keys.current["ArrowLeft"]) {
//         player.current.x = Math.max(0, player.current.x - PLAYER_SPEED);
//       }
//       if (keys.current["ArrowRight"]) {
//         player.current.x = Math.min(
//           GAME_WIDTH - PLAYER_WIDTH,
//           player.current.x + PLAYER_SPEED
//         );
//       }

//       // Player shooting
//       if (keys.current["Space"] && Date.now() - lastShot > 350) {
//         playerBullets.current.push({
//           x: player.current.x + PLAYER_WIDTH / 2 - BULLET_WIDTH / 2,
//           y: player.current.y - BULLET_HEIGHT,
//           w: BULLET_WIDTH,
//           h: BULLET_HEIGHT,
//         });
//         lastShot = Date.now();
//       }

//       // Move player bullets
//       playerBullets.current.forEach((b) => (b.y -= BULLET_SPEED));
//       playerBullets.current = playerBullets.current.filter(
//         (b) => b.y + b.h > 0
//       );

//       // Update diving enemies
//       divingEnemies.current.forEach((d) => {
//         d.x += d.vx;
//         d.y += d.vy;

//         // Check collision with player
//         if (rectsCollide(d, player.current)) {
//           lives.current -= 1;
//           d.y = GAME_HEIGHT + 100; // mark off-screen
//           if (lives.current <= 0) setGameOver(true);
//         }
//       });

//       divingEnemies.current.forEach((d) => {
//         if (!d.returning) {
//           d.x += d.vx;
//           d.y += d.vy;

//           // Collision with player
//           if (rectsCollide(d, player.current)) {
//             lives.current -= 1;
//             d.y = GAME_HEIGHT + 100; // out of screen
//             if (lives.current <= 0) setGameOver(true);
//           }

//           // If missed player and went too far
//           if (d.y > GAME_HEIGHT - 100) {
//             d.returning = true;
//             d.vx = (d.originalX - d.x) / 60;
//             d.vy = (d.originalY - d.y) / 60;
//           }
//         } else {
//           d.x += d.vx;
//           d.y += d.vy;

//           const closeX = Math.abs(d.x - d.originalX) < 2;
//           const closeY = Math.abs(d.y - d.originalY) < 2;

//           if (closeX && closeY) {
//             enemies.current.push({
//               x: d.originalX,
//               y: d.originalY,
//               w: ENEMY_WIDTH,
//               h: ENEMY_HEIGHT,
//               alive: true,
//             });
//             d.returned = true;
//           }
//         }
//       });

//       // Remove off-screen and returned divers
//       divingEnemies.current = divingEnemies.current.filter(
//         (d) => d.y < GAME_HEIGHT && !d.returned
//       );

//       // Remove off-screen divers
//       divingEnemies.current = divingEnemies.current.filter(
//         (d) => d.y < GAME_HEIGHT
//       );

//       // Move enemy bullets
//       enemyBullets.current.forEach((b) => (b.y += ENEMY_BULLET_SPEED));
//       enemyBullets.current = enemyBullets.current.filter(
//         (b) => b.y < GAME_HEIGHT
//       );

//       // Enemy movement
//       enemyMoveTick.current++;
//       if (enemyMoveTick.current >= ENEMY_MOVE_INTERVAL) {
//         let hitEdge = false;
//         for (let e of enemies.current) {
//           if (!e.alive) continue;
//           e.x += ENEMY_STEP * enemyDir.current;
//           if (e.x < 0 || e.x + ENEMY_WIDTH > GAME_WIDTH) hitEdge = true;
//         }
//         if (hitEdge) {
//           enemyDir.current *= -1;
//           for (let e of enemies.current) {
//             if (e.alive) e.y += ENEMY_HEIGHT;
//           }
//         }
//         enemyMoveTick.current = 0;
//       }

//       // Launch a diving enemy every few seconds
//       if (Date.now() - lastDiveTime.current > 2000) {
//         const topRowEnemies = enemies.current.filter(
//           (e) => e.alive && e.y === ENEMY_START_Y
//         );
//         if (topRowEnemies.length > 0) {
//           const diver =
//             topRowEnemies[Math.floor(Math.random() * topRowEnemies.length)];

//           divingEnemies.current.push({
//             ...diver,
//             originalX: diver.x,
//             originalY: diver.y,
//             vx: (player.current.x - diver.x) / 60,
//             vy: 3,
//             returning: false,
//           });

//           diver.alive = false;
//           lastDiveTime.current = Date.now();
//         }
//       }

//       // Enemy shooting
//       if (Date.now() - lastEnemyShot > 700) {
//         // Pick a random alive enemy from the bottom row of each column
//         let bottomEnemies = {};
//         enemies.current.forEach((e) => {
//           if (!e.alive) return;
//           const col = Math.round((e.x - 40) / (ENEMY_WIDTH + ENEMY_GAP));
//           if (!bottomEnemies[col] || e.y > bottomEnemies[col].y) {
//             bottomEnemies[col] = e;
//           }
//         });

//         const cols = Object.keys(bottomEnemies);
//         if (cols.length > 0) {
//           const randCol = cols[Math.floor(Math.random() * cols.length)];
//           const shooter = bottomEnemies[randCol];
//           enemyBullets.current.push({
//             x: shooter.x + ENEMY_WIDTH / 2 - BULLET_WIDTH / 2,
//             y: shooter.y + ENEMY_HEIGHT,
//             w: BULLET_WIDTH,
//             h: BULLET_HEIGHT,
//           });
//         }
//         lastEnemyShot = Date.now();
//       }

//       // Bullet-enemy collision
//       playerBullets.current.forEach((b) => {
//         enemies.current.forEach((e) => {
//           if (e.alive && rectsCollide(b, e)) {
//             e.alive = false;
//             b.y = -100; // Remove bullet
//             setScore((s) => s + 100);
//           }
//         });
//       });
//       enemies.current = enemies.current.filter((e) => e.alive);

//       // Bullet-player collision
//       enemyBullets.current.forEach((b) => {
//         if (rectsCollide(b, player.current)) {
//           b.y = GAME_HEIGHT + 100; // Remove bullet
//           lives.current -= 1;
//           if (lives.current <= 0) {
//             setGameOver(true);
//           }
//         }
//       });

//       // Enemy reaches player
//       for (let e of enemies.current) {
//         if (e.alive && e.y + ENEMY_HEIGHT >= player.current.y) {
//           setGameOver(true);
//         }
//       }

//       // Win condition
//       if (enemies.current.length === 0) {
//         setGameOver(true);
//       }

//       setRerender((r) => r + 1); // force rerender
//       requestRef.current = requestAnimationFrame(gameLoop);
//     }

//     requestRef.current = requestAnimationFrame(gameLoop);
//     return () => cancelAnimationFrame(requestRef.current);
//     // eslint-disable-next-line
//   }, [restartKey]);

//   return (
//     <div
//       style={{
//         width: GAME_WIDTH,
//         height: GAME_HEIGHT,
//         background: "radial-gradient(ellipse at center, #000 0%, #111 100%)",
//         position: "relative",
//         margin: "30px auto",
//         border: "4px solid #0ff",
//         boxShadow: "0 0 20px #0ff, 0 0 60px #00f inset",
//         overflow: "hidden",
//         fontFamily: "monospace",
//         userSelect: "none",
//       }}
//       tabIndex={0}
//     >
//       {/* Score and lives */}
//       <div
//         style={{
//           position: "absolute",
//           top: 8,
//           left: 16,
//           color: "#0ff",
//           fontWeight: "bold",
//           fontSize: 20,
//           zIndex: 2,
//           textShadow: "1px 1px 2px #000",
//         }}
//       >
//         Score: {score}
//       </div>
//       <div
//         style={{
//           position: "absolute",
//           top: 8,
//           right: 16,
//           color: "#0ff",
//           fontWeight: "bold",
//           fontSize: 20,
//           zIndex: 2,
//           textShadow: "1px 1px 2px #000",
//         }}
//       >
//         Lives: {lives.current}
//       </div>

//       {/* Player */}
//       <img
//         src={SpaceShipPlayer}
//         alt="Player"
//         style={{
//           position: "absolute",
//           left: player.current.x,
//           top: player.current.y,
//           width: PLAYER_WIDTH,
//           height: PLAYER_HEIGHT,
//           filter: "drop-shadow(0 0 8px #0ff)",
//           transform: "translateZ(0)",
//           zIndex: 2,
//           animation: "pulse 1s infinite alternate",
//         }}
//       />

//       {/* Player bullets */}
//       {playerBullets.current.map((b, i) => (
//         <div
//           key={i}
//           style={{
//             position: "absolute",
//             left: b.x,
//             top: b.y,
//             width: BULLET_WIDTH,
//             height: BULLET_HEIGHT,
//             background: "#fff",
//             borderRadius: "2px",
//             boxShadow: "0 0 4px #0ff",
//           }}
//         ></div>
//       ))}

//       {/* Diving Enemies */}
//       {divingEnemies.current.map((e, i) => (
//         <div
//           key={`diver-${i}`}
//           style={{
//             position: "absolute",
//             left: e.x,
//             top: e.y,
//             width: ENEMY_WIDTH,
//             height: ENEMY_HEIGHT,
//             background: "linear-gradient(to bottom, #ff6600 50%, #cc0000 100%)",
//             borderRadius: "6px",
//             border: "1px solid #fff",
//             boxShadow: "0 0 10px #f00",
//             transform: "rotate(15deg)",
//           }}
//         />
//       ))}

//       {/* Enemy bullets */}
//       {enemyBullets.current.map((b, i) => (
//         <div
//           key={i}
//           style={{
//             position: "absolute",
//             left: b.x,
//             top: b.y,
//             width: BULLET_WIDTH,
//             height: BULLET_HEIGHT,
//             background: "#f00",
//             borderRadius: "2px",
//             boxShadow: "0 0 4px #f00",
//           }}
//         ></div>
//       ))}

//       {/* Enemies */}
//       {enemies.current.map((e, i) =>
//         e.alive ? (
//           <div
//             key={i}
//             style={{
//               position: "absolute",
//               left: e.x,
//               top: e.y,
//               width: ENEMY_WIDTH,
//               height: ENEMY_HEIGHT,
//               background: "linear-gradient(to bottom, #f0f 50%, #800 100%)",
//               borderRadius: "6px",
//               border: "1px solid #fff",
//               boxShadow: "0 0 10px #f0f",
//               transform: "translateZ(0)",
//             }}
//           ></div>
//         ) : null
//       )}

//       {/* Game Over / Win */}
//       {gameOver && (
//         <div
//           style={{
//             position: "absolute",
//             top: "40%",
//             left: 0,
//             width: "100%",
//             color: "#fff",
//             fontSize: 36,
//             textAlign: "center",
//             textShadow: "2px 2px 8px #000",
//             zIndex: 10,
//           }}
//         >
//           {enemies.current.length === 0 ? "YOU WIN!" : "GAME OVER"}
//           <br />
//           <button
//             style={{
//               marginTop: 30,
//               fontSize: 22,
//               padding: "10px 30px",
//               background: "#0ff",
//               color: "#222",
//               border: "none",
//               borderRadius: 8,
//               cursor: "pointer",
//               fontWeight: "bold",
//               boxShadow: "0 0 8px #0ff",
//             }}
//             onClick={() => {
//               enemies.current = generateEnemies(level);

//               setRestartKey((k) => k + 1);
//             }}
//           >
//             Restart
//           </button>
//         </div>
//       )}
//       {/* Controls info */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: 8,
//           left: 20,
//           width: "100%",
//           color: "#0ff",
//           fontSize: 16,
//           textAlign: "left",
//           opacity: 0.7,
//           zIndex: 2,
//         }}
//       >
//         ← → to move, Space to shoot
//       </div>
//     </div>
//   );
// };

// export default GalaxiaGame;

// jpdf only

// import { useEffect, useState } from "react";
// import React from "react";
// import jsPDF from "jspdf";
// import "jspdf-autotable"; // Optional: For tables if needed, but we'll use basic text for simplicity
// import { API_BASE_URL } from "../../Config/Config";
// const Pop3 = () => {
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const accessToken = localStorage.getItem("other");
//   // Assuming these are defined elsewhere in your component or passed as props
//   const selectedSetNames = ["A"]; // Example: replace with actual selected sets
//   const testScheduleId = 194; // Example: replace with actual ID
//   // const API_BASE_URL = 'your-api-base-url'; // Replace with actual base URL
//   // const accessToken = 'your-access-token'; // Replace with actual token

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;

//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   // Function to generate and download PDF
//   const generatePDF = () => {
//     if (!quesPaperInfo || questionData.length === 0) {
//       console.error("No data available to generate PDF");
//       return;
//     }

//     const doc = new jsPDF({
//       orientation: "portrait",
//       unit: "pt",
//       format: "a4",
//     });

//     // Set font and styles
//     doc.setFont("helvetica");
//     doc.setFontSize(12);

//     // Add Cover Page (parsing the HTML-like string)
//     const cover = quesPaperInfo.paper_cover
//       .replace(/&lt;/g, "<")
//       .replace(/&gt;/g, ">")
//       .replace(/&amp;/g, "&")
//       .replace(/#set_name#/g, "A") // Replace placeholders as needed
//       .replace(/#total_pages#/g, "10"); // Example: calculate actual pages if needed

//     // Use jsPDF's html method (requires jspdf 2.x with html plugin)
//     doc.html(cover, {
//       callback: function (doc) {
//         doc.addPage(); // Add new page after cover
//         addContent(doc);
//       },
//       x: 10,
//       y: 10,
//       width: 580, // A4 width in pt minus margins
//       windowWidth: 800, // Adjust based on original HTML width
//     });
//   };

//   // Helper function to add question content
//   const addContent = (doc) => {
//     let yPos = 40; // Starting y-position on the page

//     // Add Header Info
//     doc.setFontSize(16);
//     doc.text(quesPaperInfo.ques_paper_name, 40, yPos);
//     yPos += 20;
//     doc.setFontSize(12);
//     doc.text(`Description: ${quesPaperInfo.description}`, 40, yPos);
//     yPos += 20;
//     doc.text(`Total Questions: ${quesPaperInfo.total_questions}`, 40, yPos);
//     yPos += 20;
//     doc.text(`Duration: ${quesPaperInfo.duration_mins} mins`, 40, yPos);
//     yPos += 20;
//     doc.text(`Total Marks: ${quesPaperInfo.total_marks}`, 40, yPos);
//     yPos += 30;

//     // Add Syllabus Chapters
//     doc.setFontSize(14);
//     doc.text("Syllabus", 40, yPos);
//     yPos += 20;
//     quesPaperInfo.subj_chap_list.forEach((subject) => {
//       doc.setFontSize(12);
//       doc.text(subject.subject_name, 40, yPos);
//       yPos += 15;
//       subject.chapters.forEach((chapter) => {
//         doc.text(`- ${chapter}`, 50, yPos);
//         yPos += 10;
//       });
//       yPos += 10;
//     });

//     // Add Sets and Questions
//     questionData.forEach((set) => {
//       doc.addPage();
//       yPos = 40;
//       doc.setFontSize(14);
//       doc.text(`Set: ${set.set_name}`, 40, yPos);
//       yPos += 20;

//       set.subjects.forEach((subject) => {
//         doc.setFontSize(12);
//         doc.text(`Subject: ${subject.subject_name}`, 40, yPos);
//         yPos += 15;

//         subject.sections.forEach((section) => {
//           doc.text(`Section: ${section.section_name}`, 40, yPos);
//           yPos += 10;
//           doc.text(`Instruction: ${section.section_instruction}`, 40, yPos);
//           yPos += 15;

//           section.questions.forEach((question) => {
//             // Clean and add question text (replace HTML entities)
//             const quesText = question.ques_text
//               .replace(/&lt;/g, "<")
//               .replace(/&gt;/g, ">")
//               .replace(/&amp;/g, "&")
//               .replace(/imgsrc=.*?(?=\s|$)/g, "[Image]"); // Placeholder for images

//             doc.text(`Q${question.set_ques_position}: ${quesText}`, 40, yPos, {
//               maxWidth: 500,
//             });
//             yPos += 20; // Adjust based on text length

//             question.options.forEach((option) => {
//               const optText = option.option_text
//                 .replace(/\\\(.*?\\\)/g, (match) => match) // Preserve LaTeX-like expressions
//                 .replace(/imgsrc=.*?(?=\s|$)/g, "[Image]");
//               doc.text(
//                 `Option ${option.set_option_position}: ${optText}`,
//                 50,
//                 yPos,
//                 { maxWidth: 490 }
//               );
//               yPos += 15;
//             });
//             yPos += 10; // Space between questions

//             if (yPos > 750) {
//               // Add new page if near bottom (A4 height ~842 pt)
//               doc.addPage();
//               yPos = 40;
//             }
//           });
//         });
//       });
//     });

//     // Add Footer Info
//     doc.addPage();
//     yPos = 40;
//     doc.text(`Client: ${quesPaperInfo.footer.client_name}`, 40, yPos);
//     yPos += 15;
//     doc.text(`Address: ${quesPaperInfo.footer.address}`, 40, yPos);

//     // Save the PDF
//     doc.save(`${quesPaperInfo.ques_paper_name}.pdf`);
//   };

//   return (
//     <div>
//       <button onClick={generatePDF}>Download PDF</button>
//     </div>
//   );
// };

// export default Pop3;

// jpdf with html2canvas

// import React, { useEffect, useRef, useState } from "react";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { API_BASE_URL } from "../../Config/Config";

// const Pop3 = () => {
//   const [questionData, setQuestionData] = useState([]);
//   const [quesPaperInfo, setQuesPaperInfo] = useState(null);
//   const accessToken = localStorage.getItem("other");
//   const selectedSetNames = ["A"];
//   const testScheduleId = 194;
//   const printRef = useRef();

//   useEffect(() => {
//     if (selectedSetNames.length === 0) return;
//     const fetchData = async () => {
//       const setParams = selectedSetNames
//         .map((set) => `set_names=${set}`)
//         .join("&");
//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-full-question-paper-by-test-shedule-id-and-set?test_schedule_id=${testScheduleId}&${setParams}`,
//           {
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               accept: "application/json",
//             },
//           }
//         );
//         const data = await response.json();
//         setQuestionData(data.sets || []);
//         setQuesPaperInfo(data.ques_paper_info || null);
//       } catch (error) {
//         console.error("Error fetching question paper data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   const generatePDF = async () => {
//     if (!quesPaperInfo || questionData.length === 0) {
//       console.error("No data available to generate PDF");
//       return;
//     }

//     // Temporarily show hidden printable area
//     printRef.current.style.display = "block";

//     // Capture the content as image using html2canvas
//     const canvas = await html2canvas(printRef.current, { scale: 2 });
//     const imgData = canvas.toDataURL("image/png");

//     // Hide printable area again
//     printRef.current.style.display = "none";

//     // Create jsPDF and add image
//     const pdf = new jsPDF({
//       orientation: "portrait",
//       unit: "pt",
//       format: "a4",
//     });
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     // Fit image to page (keep aspect ratio)
//     const imgProps = {
//       width: canvas.width,
//       height: canvas.height,
//     };
//     const ratio = Math.min(pageWidth / imgProps.width, pageHeight / imgProps.height);
//     const imgWidth = imgProps.width * ratio;
//     const imgHeight = imgProps.height * ratio;

//     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//     pdf.save(`${quesPaperInfo.ques_paper_name}.pdf`);
//   };

//   // Render the full question paper in a hidden area
//   return (
//     <div>
//       <button onClick={generatePDF}>Download PDF</button>
//       <div ref={printRef} style={{ display: "none", padding: 32, background: "#fff", width: 794 }}>
//         {quesPaperInfo && (
//           <div>
//             {/* Cover page */}
//             <div dangerouslySetInnerHTML={{
//               __html: quesPaperInfo.paper_cover
//                 .replace(/&lt;/g, "<")
//                 .replace(/&gt;/g, ">")
//                 .replace(/&amp;/g, "&")
//                 .replace(/#set_name#/g, "A")
//                 .replace(/#total_pages#/g, "10")
//             }} />
//             {/* Details */}
//             <h2>{quesPaperInfo.ques_paper_name}</h2>
//             <p>Description: {quesPaperInfo.description}</p>
//             <p>Total Questions: {quesPaperInfo.total_questions}</p>
//             <p>Duration: {quesPaperInfo.duration_mins} mins</p>
//             <p>Total Marks: {quesPaperInfo.total_marks}</p>
//             {/* Syllabus */}
//             <h3>Syllabus</h3>
//             {quesPaperInfo.subj_chap_list.map((subject, sidx) => (
//               <div key={sidx}>
//                 <strong>{subject.subject_name}</strong>
//                 <ul>
//                   {subject.chapters.map((chapter, cidx) => (
//                     <li key={cidx}>{chapter}</li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//             {/* Questions */}
//             {questionData.map((set, setIdx) => (
//               <div key={setIdx} style={{ marginTop: 32 }}>
//                 <h3>Set: {set.set_name}</h3>
//                 {set.subjects.map((subject, subjIdx) => (
//                   <div key={subjIdx}>
//                     <div><strong>Subject: {subject.subject_name}</strong></div>
//                     {subject.sections.map((section, secIdx) => (
//                       <div key={secIdx}>
//                         <div>Section: {section.section_name}</div>
//                         <div>Instruction: {section.section_instruction}</div>
//                         <ol>
//                           {section.questions.map((question, qidx) => (
//                             <li key={qidx}>
//                               <div>
//                                 {/* Replace imgsrc with placeholder [Image] */}
//                                 <span dangerouslySetInnerHTML={{
//                                   __html: question.ques_text
//                                     .replace(/&lt;/g, "<")
//                                     .replace(/&gt;/g, ">")
//                                     .replace(/&amp;/g, "&")
//                                     .replace(/imgsrc=.*?(?=\s|$)/g, "[Image]")
//                                 }} />
//                               </div>
//                               <ul>
//                                 {question.options.map((option, oidx) => (
//                                   <li key={oidx}>
//                                     <span dangerouslySetInnerHTML={{
//                                       __html: option.option_text
//                                         .replace(/\\\(.*?\\\)/g, (match) => match)
//                                         .replace(/imgsrc=.*?(?=\s|$)/g, "[Image]")
//                                     }} />
//                                   </li>
//                                 ))}
//                               </ul>
//                             </li>
//                           ))}
//                         </ol>
//                       </div>
//                     ))}
//                   </div>
//                 ))}
//               </div>
//             ))}
//             {/* Footer */}
//             <div style={{ marginTop: 40 }}>
//               <div>Client: {quesPaperInfo.footer.client_name}</div>
//               <div>Address: {quesPaperInfo.footer.address}</div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Pop3;

// import React, { useState, useEffect } from "react";
// import "./pop.css"; // We'll create this CSS file

// const Pop3 = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleModal = () => {
//     setIsOpen(!isOpen);
//   };

//   // Function to extract scope ref id names from API response
//   const extractScopeRefIdNames = (apiResponse) => {
//     if (!apiResponse?.data || !Array.isArray(apiResponse.data)) {
//       return [];
//     }

//     const results = [];

//     apiResponse.data.forEach((testSeries) => {
//       const scopeRefIds = testSeries.scope_ref_ids || [];

//       // Extract just the names
//       const names = scopeRefIds
//         .filter((ref) => ref.name) // Only include items with names
//         .map((ref) => ref.name);

//       if (names.length > 0) {
//         if (names.length === 1) {
//           results.push(names[0]);
//         } else {
//           // Join multiple names with " , "
//           results.push(names.join(" , "));
//         }
//       }
//     });

//     return results;
//   };

//   // React implementation
//   const [scopeRefNames, setScopeRefNames] = useState([]);

//   useEffect(() => {
//     const fetchTestSeries = async () => {
//       try {
//         const response = await fetch(
//           "https://dev.dse-cc-api.com/coaching-collaborator-api/api/v1/get-test-series-list-by-branch/?client_branch_id=1",
//           {
//             headers: {
//               Authorization:
//                 "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzaWRkaGFydGgiLCJleHAiOjE3NTcwMTQ5NjN9.t6Yeh1OAPZl7wPjimxXdigtREtEhUqtCg7eX2U9Ej0U",
//             },
//           }
//         );

//         if (response.ok) {
//           const data = await response.json();
//           const extractedNames = extractScopeRefIdNames(data);
//           setScopeRefNames(extractedNames);
//         }
//       } catch (error) {
//         console.error("Error fetching test series:", error);
//       }
//     };

//     fetchTestSeries();
//   }, []);

//   return (
//     <>
//       {/* Trigger Button - positioned on right side middle */}
//       <button className="trigger-button" onClick={toggleModal}>
//         Open
//       </button>

//       {/* Modal Overlay */}
//       {isOpen && (
//         <div className="modal-overlay" onClick={toggleModal}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             {/* Close Button - positioned outside top-left of main div */}
//             <button className="close-button" onClick={toggleModal}>
//               ✕
//             </button>

//             {/* Main Content */}
//             <div className="modal-body">
//               <h2>Modal Content</h2>
//               <p>
//                 This is the main div content that appears when the button is
//                 clicked.
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       <div>{scopeRefNames}</div>
//     </>
//   );
// };

// export default Pop3;

// import React, { useState, useEffect } from "react";
// import { UAParser } from "ua-parser-js";

// const Pop3 = () => {
//   const [userInfo, setUserInfo] = useState({
//     ipAddress: null,
//     location: null,
//     browser: null,
//     operatingSystem: null,
//     deviceType: null,
//     screenResolution: null,
//     isLoading: true,
//     error: null,
//   });

//   // Enhanced Windows Detection with Client Hints
//   const detectWindowsWithClientHints = async () => {
//     try {
//       // Check if User-Agent Client Hints are supported (Chromium browsers only)
//       if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
//         const clientHints = await navigator.userAgentData.getHighEntropyValues([
//           "platformVersion",
//           "architecture",
//           "bitness"
//         ]);

//         if (navigator.userAgentData.platform === "Windows") {
//           const majorPlatformVersion = parseInt(clientHints.platformVersion.split('.')[0]);

//           let windowsVersion;
//           if (majorPlatformVersion >= 13) {
//             windowsVersion = "Windows 11";
//           } else if (majorPlatformVersion > 0) {
//             windowsVersion = "Windows 10";
//           } else {
//             windowsVersion = "Windows (Legacy)";
//           }

//           // Add architecture info if available
//           const arch = clientHints.architecture && clientHints.bitness
//             ? `${clientHints.architecture}${clientHints.bitness}`
//             : "";

//           return arch ? `${windowsVersion} (${arch})` : windowsVersion;
//         }
//       }
//       return null; // Not Windows or Client Hints not supported
//     } catch (error) {
//       console.warn("Client Hints detection failed:", error);
//       return null;
//     }
//   };

//   // Comprehensive Browser Detection with UAParser.js and Client Hints
//   const detectBrowserWithUAParser = async () => {
//     const parser = new UAParser();
//     let result = parser.getResult();

//     try {
//       // Try to get enhanced data with Client Hints (Chromium browsers only)
//       const osWithClientHints = await parser.getOS().withClientHints();
//       if (osWithClientHints && osWithClientHints.name) {
//         result.os = osWithClientHints;
//       }
//     } catch (error) {
//       console.warn("UAParser Client Hints failed, using standard detection:", error);
//     }

//     // Try our custom Windows detection as a fallback/enhancement
//     const customWindowsDetection = await detectWindowsWithClientHints();
//     if (customWindowsDetection) {
//       result.os.name = customWindowsDetection.split(' (')[0]; // Get OS name part
//       result.os.version = customWindowsDetection.includes('(')
//         ? customWindowsDetection.match(/\(([^)]+)\)/)?.[1] || result.os.version
//         : result.os.version;
//     }

//     return {
//       browser: `${result.browser.name || "Unknown"} ${result.browser.version || ""}`.trim(),
//       os: `${result.os.name || "Unknown"} ${result.os.version || ""}`.trim(),
//       device: result.device.type || "Desktop",
//       engine: `${result.engine.name || "Unknown"} ${result.engine.version || ""}`.trim(),
//       cpu: result.cpu.architecture || "Unknown",
//     };
//   };

//   // Enhanced Device Detection
//   const detectDevice = () => {
//     const userAgent = navigator.userAgent.toLowerCase();
//     const screenWidth = window.screen.width;

//     // Enhanced mobile detection patterns
//     const mobilePatterns = [
//       /android/i, /webos/i, /iphone/i, /ipad/i, /ipod/i,
//       /blackberry/i, /windows phone/i, /mobile/i
//     ];

//     const tabletPatterns = [
//       /ipad/i, /android(?=.*tablet)/i, /tablet/i, /kindle/i
//     ];

//     const isMobile = mobilePatterns.some(pattern => pattern.test(userAgent));
//     const isTablet = tabletPatterns.some(pattern => pattern.test(userAgent)) ||
//                      (screenWidth >= 768 && screenWidth <= 1024 && isMobile);

//     if (isTablet) return "Tablet";
//     if (isMobile) return "Mobile";
//     return "Desktop/Computer";
//   };

//   // IP and Location Detection (unchanged)
//   const fetchIPInfo = async () => {
//     try {
//       const apis = [
//         {
//           url: "https://ipapi.co/json/",
//           handler: (data) => ({
//             ip: data.ip,
//             location: `${data.city}, ${data.region}, ${data.country_name}`,
//           }),
//         },
//         {
//           url: "https://ip-api.com/json/",
//           handler: (data) => ({
//             ip: data.query,
//             location: `${data.city}, ${data.regionName}, ${data.country}`,
//           }),
//         },
//         {
//           url: "https://ipinfo.io/json",
//           handler: (data) => ({
//             ip: data.ip,
//             location: `${data.city}, ${data.region}, ${data.country}`,
//           }),
//         },
//       ];

//       for (const api of apis) {
//         try {
//           const response = await fetch(api.url);
//           if (response.ok) {
//             const data = await response.json();
//             return api.handler(data);
//           }
//         } catch (apiError) {
//           console.warn(`Failed to fetch from ${api.url}:`, apiError);
//           continue;
//         }
//       }

//       throw new Error("All IP APIs failed");
//     } catch (error) {
//       console.error("Error fetching IP info:", error);
//       return {
//         ip: "Unable to detect",
//         location: "Unable to detect",
//       };
//     }
//   };

//   // Initialize user info detection
//   useEffect(() => {
//     const getUserInfo = async () => {
//       try {
//         const [ipInfo, uaParserResult] = await Promise.all([
//           fetchIPInfo(),
//           detectBrowserWithUAParser()
//         ]);

//         const device = detectDevice();

//         setUserInfo({
//           ipAddress: ipInfo.ip,
//           location: ipInfo.location,
//           browser: uaParserResult.browser,
//           operatingSystem: uaParserResult.os,
//           deviceType: uaParserResult.device !== "Desktop" ? uaParserResult.device : device,
//           screenResolution: {
//             width: window.screen.width,
//             height: window.screen.height,
//             devicePixelRatio: window.devicePixelRatio || 1,
//           },
//           isLoading: false,
//           error: null,
//         });

//         // Enhanced debugging
//         console.log("=== ENHANCED USER INFORMATION DETECTED ===");
//         console.log("IP Address:", ipInfo.ip);
//         console.log("Location:", ipInfo.location);
//         console.log("Browser:", uaParserResult.browser);
//         console.log("Operating System:", uaParserResult.os);
//         console.log("Device Type:", uaParserResult.device);
//         console.log("Engine:", uaParserResult.engine);
//         console.log("CPU:", uaParserResult.cpu);
//         console.log("Client Hints Supported:", !!navigator.userAgentData);
//       } catch (error) {
//         setUserInfo((prev) => ({
//           ...prev,
//           isLoading: false,
//           error: error.message,
//         }));
//       }
//     };

//     getUserInfo();
//   }, []);

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <h2>Enhanced User Information Detection</h2>

//       {userInfo.isLoading ? (
//         <div>Detecting user information...</div>
//       ) : (
//         <div style={{ backgroundColor: "#f5f5f5", padding: "15px", borderRadius: "5px" }}>
//           <div><strong>IP Address:</strong> {userInfo.ipAddress}</div>
//           <div><strong>Location:</strong> {userInfo.location}</div>
//           <div><strong>Browser:</strong> {userInfo.browser}</div>
//           <div><strong>Operating System:</strong> {userInfo.operatingSystem}</div>
//           <div><strong>Device Type:</strong> {userInfo.deviceType}</div>
//           <div><strong>Screen Resolution:</strong> {userInfo.screenResolution?.width} x {userInfo.screenResolution?.height}</div>
//           <div><strong>Client Hints Supported:</strong> {navigator.userAgentData ? "Yes (Chromium)" : "No (Firefox/Safari)"}</div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Pop3;

// import React from 'react';
// import { useSelector } from 'react-redux';

// const Pop3 = () => {
//   // Safe destructuring with default values
//   const userInfoState = useSelector(state => state.UserBrowserInfo);

//   // Handle case where userInfo slice might not exist
//   const { browserInfo = {}, isUserInfoLoaded = false } = userInfoState || {};

//   // Provide default values for browserInfo properties
//   const {
//     ipAddress = null,
//     location = null,
//     browser = null,
//     operatingSystem = null,
//     deviceType = null,
//     screenResolution = null,
//     isLoading = true,
//     error = null,
//   } = browserInfo;

//   return (
//     <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
//       <h3>User Browser Information</h3>
//       {isLoading ? (
//         <div>Loading user information...</div>
//       ) : error ? (
//         <div style={{ color: 'red' }}>Error: {error}</div>
//       ) : isUserInfoLoaded ? (
//         <div style={{  padding: "15px", borderRadius: "5px" }}>
//           <div><strong>IP Address:</strong> {ipAddress || 'Not detected'}</div>
//           <div><strong>Location:</strong> {location || 'Not detected'}</div>
//           <div><strong>Browser:</strong> {browser || 'Not detected'}</div>
//           <div><strong>Operating System:</strong> {operatingSystem || 'Not detected'}</div>
//           <div><strong>Device Type:</strong> {deviceType || 'Not detected'}</div>
//           <div><strong>Screen Resolution:</strong> {screenResolution ? `${screenResolution.width} x ${screenResolution.height}` : 'Not detected'}</div>
//           <div><strong>Client Hints Supported:</strong> {navigator.userAgentData ? "Yes (Chromium)" : "No (Firefox/Safari)"}</div>
//         </div>
//       ) : (
//         <p>User information not available. Please login first.</p>
//       )}
//     </div>
//   );
// };

// export default Pop3;

// import React, { useEffect } from "react";

// const Pop3 = () => {
//   useEffect(() => {
//     localStorage.setItem("clientId", "1");
//     localStorage.setItem("clientBranchId", "1");
//     localStorage.setItem("user_name", "dbose10");
//     localStorage.setItem("userId", "4");
//     localStorage.setItem("isLoggedIn", "true");
//   }, []);

//   return <div>pop3</div>;
// };

// export default Pop3;

import { useState, useRef } from "react";
import EndPoints from "../../Api/Endpoints";

/**
 * Custom React hook to track field changes and save audit trail
 * @param {Object} initialData - The data object when page loads (before edits) - NOT USED for saveAuditWithData
 * @param {Object} auditConfig - Configuration for audit trail { clientBranchId, screenId, userName }
 * @returns {Object} { saveAuditWithData, getChanges, resetChanges }
 */
export default function useFieldChangeTracker(
  initialData = {},
  auditConfig = {}
) {
  const [changes, setChanges] = useState([]);
  const isInitialized = useRef(false);

  /**
   * Get all changed fields (if using trackChange method)
   */
  const getChanges = () => changes;

  /**
   * ✅ Save audit trail with explicit initial and current data
   * @param {Object} initialDataSnapshot - The unchanged/initial data
   * @param {Object} currentDataSnapshot - The changed/current data
   * @returns {Promise<Object>} { success, data/message }
   */
  const saveAuditWithData = async (
    initialDataSnapshot,
    currentDataSnapshot
  ) => {
    const { clientBranchId, screenId, userName } = auditConfig;

    // Validate audit config
    if (!clientBranchId || !screenId || !userName) {
      console.error("Audit config missing required fields:", auditConfig);
      return {
        success: false,
        message:
          "Missing audit configuration (clientBranchId, screenId, or userName)",
      };
    }

    // Validate input data
    if (!initialDataSnapshot || !currentDataSnapshot) {
      console.error("Initial or current data snapshot is missing");
      return {
        success: false,
        message: "Missing data snapshots for audit",
      };
    }

    // Compare initial and current data to find changes
    const auditChanges = [];
    const allKeys = new Set([
      ...Object.keys(initialDataSnapshot),
      ...Object.keys(currentDataSnapshot),
    ]);

    allKeys.forEach((key) => {
      const oldValue = initialDataSnapshot[key];
      const newValue = currentDataSnapshot[key];

      // Compare values (deep comparison for objects/arrays)
      const oldValueStr =
        typeof oldValue === "object"
          ? JSON.stringify(oldValue)
          : String(oldValue || "");
      const newValueStr =
        typeof newValue === "object"
          ? JSON.stringify(newValue)
          : String(newValue || "");

      if (oldValueStr !== newValueStr) {
        auditChanges.push({
          column_name: key,
          old_value: oldValueStr,
          new_value: newValueStr,
        });
      }
    });

    // No changes to audit
    if (auditChanges.length === 0) {
      console.log("ℹ️ No changes detected to audit");
      return { success: true, message: "No changes to audit" };
    }

    // Construct payload
    const payload = {
      client_branch_id: clientBranchId,
      screen_id: screenId,
      user_name: userName,
      changes: auditChanges,
    };

    console.log("🔍 Audit Payload:", payload);

    try {
      const accessToken =
        localStorage.getItem("other") || sessionStorage.getItem("other");

      if (!accessToken) {
        throw new Error("No access token found");
      }

      const response = await fetch(`${EndPoints.TrackerOrTransactionAudit}`, {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `API error: ${response.status}`);
      }

      const result = await response.json();
      console.log("✅ Audit trail saved successfully:", result);
      return { success: true, data: result };
    } catch (error) {
      console.error("❌ Error saving audit trail:", error);
      return { success: false, message: error.message };
    }
  };

  /**
   * Reset changes (clears the changes array)
   */
  const resetChanges = () => {
    setChanges([]);
  };

  return {
    getChanges,
    resetChanges,
    saveAuditWithData,
  };
}
